/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { forwardRef, useCallback, useEffect, useMemo, useState } from "react"
import { insertUpdateTimesheets, createUpdateTimesheet, deleteTimeSheet, getAllFunctions, getAllServiceCategories, getAllTimeSheets, getProjects, getServiceDesiplines, getUserFavourite, submitTimesheet, getHolidayByCountryAndYear, getAllTimeSheetPreview, submitTimeSheetPreview } from "../../services/ApiServices"
import Loader from "../../components/Loader/Loader"
import ReactDatePicker from "react-datepicker"
import { handleError } from "../../const"
import { useSelector } from "react-redux"
import { Tooltip } from 'react-tooltip'
import toast from "react-hot-toast"
import Select from "react-select"
import swal from "sweetalert"
import moment from "moment"
import $, { error } from "jquery"
import "./Timesheet.scss"


const Timesheet = () => {
    const currentUser = useSelector((state) => state.MSALAuth.currentUser)

    const [isLoading, setIsLoading] = useState(false)
    const [isPromiseLoading, setIsPromiseLoading] = useState(false)
    const [isAutoSaving, setIsAutoSaving] = useState(false)
    const [isPreviewSubmit, setIsPreviewSubmit] = useState(false)
    const [isGetAllTimesheetLoading, setIsGetAllTimesheetLoading] = useState(false)
    // const [AddingFavoriteFlag, setAddingFavoriteFlag] = useState({ flag: false, Data: {} })

    const [allTimesheetsResponse, setAllTimesheetsResponse] = useState([])
    const [allTimesheets, setAllTimesheets] = useState([])
    const [allProjects, setAllProjects] = useState([])
    const [allServiceCategories, setAllServiceCategories] = useState([])
    const [allFunctions, setAllFunctions] = useState([])
    const [allServiceDisciplines, setAllServiceDisciplines] = useState([])
    const [allFourites, setAllFourites] = useState([])
    const [allHolidays, setAllHolidays] = useState([])

    const [sequenceData, setSequenceData] = useState([])
    const [submitedMonthArray, setSubmitedMonthArray] = useState([])
    const [defaultHolidaySelection, setDefaultHolidaySelection] = useState({ FunctionId: 0, ServiceCategoriesId: 0, ServiceDisciplinesId: 0 })
    const [inputFunction, setInputFunction] = useState(0)
    const [inputServiceCategory, setInputServiceCategory] = useState(0)
    const [inputServiceDiscipline, setInputServiceDiscipline] = useState(0)
    const [inputProject, setInputProject] = useState(0)
    const [inputComment, setInputComment] = useState("")
    const [inputSequence, setInputSequence] = useState(0)
    const [inputIsMobile, setInputIsMobile] = useState(false)
    const [inputNotes, setInputNotes] = useState("")
    const [inputSeqData, setInputSeqData] = useState({})

    const [userUpnPa, setUserUpnPa] = useState((currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === currentUser?.Data?.UPN)?.UPN ?? "")
    const [calendarDate, setCalendarDate] = useState(moment().format("YYYY-MM-DD"))
    const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 480)
    const [currentWeek, setCurrentWeek] = useState([])

    const [disableCondition1, setDisableCondition1] = useState(false)
    const [disableCondition2, setDisableCondition2] = useState(false)
    const [disableCondition3, setDisableCondition3] = useState(false)
    const [disableCondition4, setDisableCondition4] = useState(false)
    const [disableCondition5, setDisableCondition5] = useState(false)
    const [lockPeriodDisableCondition, setLockPeriodDisableCondition] = useState(false)
    const [newDisableCondi, setNewDisableCondi] = useState([])
    const [lockedMonth, setLockedMonth] = useState([])

    // Copy Modal
    const [checkAllTimesheets, setCheckAllTimesheets] = useState([])
    const [sequenceCheckData, setSequenceCheckData] = useState([])
    const [checkArray, setCheckArray] = useState([])
    const [checkDate, setCheckDate] = useState(moment().format("YYYY-MM-DD"))
    const [isCheckSubmited, setIsCheckSubmited] = useState(false)
    const [isCopyModalOpen, setIsCopyModalOpen] = useState(false)

    const [shouldCallSave, setShouldCallSave] = useState(false)
    const [accordionId, setAccordionId] = useState(null)
    const [expandAll, setExpandAll] = useState(false);
    const [isOpen, setIsOpen] = useState(false)
    const [allTimeSheetPreview, setAllTimeSheetPreview] = useState([])
    const [previewData, setPreviewData] = useState([])
    const [isPreviewModal, setIsPreviewModal] = useState(false)

    const weekDates = useMemo(() => {
        let dates = []

        const weekStart = isMobileView
            ? moment(calendarDate).format("YYYY-MM-DD")
            : moment(calendarDate).startOf("isoWeek").format("YYYY-MM-DD")
        Array.from(Array(isMobileView ? 1 : 7), (_, i) => i + 1)?.forEach((_, i) => {
            dates.push(moment(weekStart).add(i, "d").format("YYYY-MM-DD"))
        })

        return dates
    }, [calendarDate, isMobileView])

    const start = weekDates[0]
    const end = weekDates[weekDates?.length - 1]

    const [tooltipVisible, setTooltipVisible] = useState({})

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    // Remove Duplicate Sequence
    const removeDupe = (timesheet) => {
        let unique = [];
        if (timesheet?.length > 0) {
            timesheet?.forEach((e) => {
                if (!unique.includes(e?.Sequence)) {
                    unique.push(e?.Sequence);
                }
            });
        } else {
            if (allFourites?.length > 0) {
                allFourites?.forEach((e, index) => {
                    unique.push(index + 1);
                });
            } else {
                unique.push(1)
            }
        }
        return unique;
    }

    const checkIsSubmitedMonthWise = (sequenceDateData) => {
        const tempIsSubmitedMonthWise = sequenceDateData?.map((seq) => {
            const months = {};
            // Group seqArray items by month
            seq?.seqArray?.forEach((week) => {
                const month = moment(week?.Date, "YYYY-MM-DD").format("YYYY-MM");
                if (!months[month]) {
                    months[month] = [];
                }
                months[month].push(week);
            });

            // Check if any month has IsSubmited set to true
            const hasSubmittedMonth = Object.values(months)?.some((monthArray) =>
                monthArray?.some((item) => item?.IsSubmited)
            );

            // Update IsSubmited for all items in months with submitted items
            const updatedSeqArray = seq?.seqArray?.map((week) => {
                const month = moment(week?.Date, "YYYY-MM-DD").format("YYYY-MM");
                if (hasSubmittedMonth && months[month]?.some((item) => item?.IsSubmited)) {
                    return {
                        ...week,
                        IsSubmited: true
                    };
                }
                return week;
            });

            return {
                ...seq,
                seqArray: updatedSeqArray
            };
        });

        const submitedMonth = tempIsSubmitedMonthWise?.map((seq) => ({
            ...seq,
            seqArray: seq?.seqArray?.map((data) => ({
                ...data,
                IsSubmited: submitedMonthArray?.length > 0
                    ? submitedMonthArray?.some((month) => moment(month, "MMMM").format("MM") === moment(data?.Date, "YYYY-MM-DD").format("MM"))
                    : false
            }))
        }))

        return submitedMonth
    }

    const removeDupeNew = (timesheet) => {
        let unique = [];
        if (timesheet?.length > 0) {
            timesheet?.forEach((e) => {
                const exists = unique.some(
                    (item) => item?.Sequence === e?.Sequence
                        && item?.ProjectId === e?.ProjectId
                        && item?.ServiceCategoriesId === e?.ServiceCategoriesId
                        && item?.ServiceDisciplinesId === e?.ServiceDisciplinesId
                );

                if (!exists) {
                    unique.push({
                        Sequence: e?.Sequence,
                        ProjectId: e?.ProjectId,
                        ServiceCategoriesId: e?.ServiceCategoriesId,
                        ServiceDisciplinesId: e?.ServiceDisciplinesId
                    });
                }
            });
        } else {
            if (allFourites?.length > 0) {
                allFourites?.forEach((e, index) => {
                    unique.push({ Sequence: index + 1, });
                });
            } else {
                unique.push({ Sequence: 1, });
            }
        }

        return unique;
    }

    // Sequence Sorting
    useEffect(() => {
        let sequenceDateData = []
        removeDupeNew(allTimesheets)?.forEach((d, index) => {
            const currentSequenceTotalArray = allTimesheets?.filter((timeSheet) => timeSheet?.Sequence === d?.Sequence)
            const isMobileTrueArray = currentSequenceTotalArray?.filter((timeSheet) => timeSheet?.IsMobile)
            const isMobileFalseArray = currentSequenceTotalArray?.filter((timeSheet) => !timeSheet?.IsMobile)

            if (allTimesheets.length > 0) {
                if (isMobileTrueArray?.length > 0) {
                    sequenceDateData.push({
                        Sequence: d?.Sequence,
                        IsMobile: true,
                        seqArray: weekDates?.map((date, dateIndex) => {
                            const defaultData = allTimesheets?.filter((timeSheet) => timeSheet?.IsMobile)?.find((timesheet) => timesheet?.Sequence === d?.Sequence &&
                                timesheet?.ProjectId === d?.ProjectId)
                            const data = allTimesheets?.filter((timeSheet) => timeSheet?.IsMobile)?.find((timesheet) =>
                                timesheet?.Sequence === d?.Sequence &&
                                timesheet?.Date === date && timesheet?.ProjectId === d?.ProjectId
                            )
                            return data ? (
                                data
                            ) : allTimesheets?.filter((timeSheet) => timeSheet?.IsMobile).length > 0 ? {
                                ...defaultData,
                                Id: 0,
                                Hour: "",
                                Date: date,
                                IndexId: dateIndex,
                                Notes: "",
                            } : allFourites[index]
                                ? ({
                                    Comment: "",
                                    Date: date,
                                    FunctionId: allFourites[index]?.FunctionId,
                                    Hour: "",
                                    IsMobile: false,
                                    Hours: "00:00:00",
                                    Id: 0,
                                    IndexId: dateIndex,
                                    IsSubmited: false,
                                    ProjectId: allFourites[index]?.ProjectId,
                                    Sequence: d?.Sequence,
                                    ServiceCategoriesId: allFourites[index]?.ServiceCategoriesId,
                                    ServiceDisciplinesId: allFourites[index]?.ServiceDisciplinesId,
                                    User: (currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === userUpnPa)?.UPN,
                                    Notes: "",
                                    IsFavourite: true,
                                }) : ({
                                    Comment: "",
                                    Date: date,
                                    FunctionId: 0,
                                    Hour: "",
                                    Hours: "00:00:00",
                                    IsMobile: false,
                                    Id: 0,
                                    IndexId: dateIndex,
                                    IsSubmited: false,
                                    ProjectId: 0,
                                    Sequence: 1,
                                    ServiceCategoriesId: 0,
                                    ServiceDisciplinesId: 0,
                                    User: (currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === userUpnPa)?.UPN,
                                    Notes: "",
                                    IsFavourite: false
                                })
                        })
                    })
                }

                if (isMobileFalseArray?.length > 0) {
                    sequenceDateData.push({
                        Sequence: d?.Sequence,
                        IsMobile: false,
                        seqArray: weekDates?.map((date, dateIndex) => {
                            const defaultData = allTimesheets?.filter((timeSheet) => !timeSheet?.IsMobile)?.find((timesheet) =>
                                timesheet?.Sequence === d?.Sequence &&
                                timesheet?.ProjectId === d?.ProjectId &&
                                timesheet?.ServiceCategoriesId === d?.ServiceCategoriesId &&
                                timesheet?.ServiceDisciplinesId === d?.ServiceDisciplinesId
                            )
                            const data = allTimesheets?.filter((timeSheet) => !timeSheet?.IsMobile)?.find((timesheet) =>
                                timesheet?.Date === date &&
                                timesheet?.Sequence === d?.Sequence &&
                                timesheet?.ProjectId === d?.ProjectId &&
                                timesheet?.ServiceCategoriesId === d?.ServiceCategoriesId &&
                                timesheet?.ServiceDisciplinesId === d?.ServiceDisciplinesId
                            )

                            return data ? (
                                data
                            ) : allTimesheets?.filter((timeSheet) => !timeSheet?.IsMobile).length > 0 ? {
                                ...defaultData,
                                Id: 0,
                                Hour: "",
                                Date: date,
                                IndexId: dateIndex,
                                Notes: "",
                                IsSubmited: false
                            } : allFourites[index]
                                ? ({
                                    Comment: "",
                                    Date: date,
                                    FunctionId: allFourites[index]?.FunctionId,
                                    Hour: "",
                                    IsMobile: false,
                                    Hours: "00:00:00",
                                    Id: 0,
                                    IndexId: dateIndex,
                                    IsSubmited: false,
                                    ProjectId: allFourites[index]?.ProjectId,
                                    Sequence: d?.Sequence,
                                    ServiceCategoriesId: allFourites[index]?.ServiceCategoriesId,
                                    ServiceDisciplinesId: allFourites[index]?.ServiceDisciplinesId,
                                    User: (currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === userUpnPa)?.UPN,
                                    Notes: "",
                                    IsFavourite: true,
                                }) : ({
                                    Comment: "",
                                    Date: date,
                                    FunctionId: 0,
                                    Hour: "",
                                    Hours: "00:00:00",
                                    Id: 0,
                                    IndexId: dateIndex,
                                    IsMobile: false,
                                    IsSubmited: false,
                                    ProjectId: 0,
                                    Sequence: 1,
                                    ServiceCategoriesId: 0,
                                    ServiceDisciplinesId: 0,
                                    User: (currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === userUpnPa)?.UPN,
                                    Notes: "",
                                    IsFavourite: false
                                })
                        })
                    })
                }
            } else {
                sequenceDateData.push({
                    Sequence: d?.Sequence,
                    IsMobile: false,
                    seqArray: weekDates?.map((date, dateIndex) => {
                        const defaultData = allTimesheets?.find((timesheet) => timesheet?.Sequence === d?.Sequence &&
                            timesheet?.ProjectId === d?.ProjectId)
                        const data = allTimesheets?.find((timesheet) =>
                            timesheet?.Sequence === d?.Sequence &&
                            timesheet?.Date === date && timesheet?.ProjectId === d?.ProjectId
                        )

                        return data ? (
                            data
                        ) : allTimesheets.length > 0 ? {
                            ...defaultData,
                            Id: 0,
                            Hour: "",
                            Date: date,
                            IndexId: dateIndex,
                            Notes: ""
                        } : allFourites[index]
                            ? ({
                                Comment: "",
                                Date: date,
                                FunctionId: allFourites[index]?.FunctionId,
                                Hour: "",
                                Hours: "00:00:00",
                                Id: 0,
                                IndexId: dateIndex,
                                IsMobile: false,
                                IsSubmited: false,
                                ProjectId: allFourites[index]?.ProjectId,
                                Sequence: d?.Sequence,
                                ServiceCategoriesId: allFourites[index]?.ServiceCategoriesId,
                                ServiceDisciplinesId: allFourites[index]?.ServiceDisciplinesId,
                                User: (currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === userUpnPa)?.UPN,
                                Notes: "",
                                IsFavourite: true,
                            }) : ({
                                Comment: "",
                                Date: date,
                                FunctionId: 0,
                                Hour: "",
                                Hours: "00:00:00",
                                Id: 0,
                                IndexId: dateIndex,
                                IsMobile: false,
                                IsSubmited: false,
                                ProjectId: 0,
                                Sequence: 1,
                                ServiceCategoriesId: 0,
                                ServiceDisciplinesId: 0,
                                User: (currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === userUpnPa)?.UPN,
                                Notes: "",
                                IsFavourite: false,

                            })
                    })
                })
            }
        })
        const checkIsSubmitedResponse = checkIsSubmitedMonthWise(sequenceDateData)

        const isHolidayCheck = checkIsSubmitedResponse?.map((seq) => ({
            ...seq,
            seqArray: seq?.seqArray?.map((data) => ({
                ...data,
                // Hour: allHolidays.find((holiday) => moment(holiday?.Date).format("YYYY-MM-DD") === data?.Date) ? "" : data?.Hour,
                IsHoliday: allHolidays.find((holiday) => moment(holiday?.Date).format("YYYY-MM-DD") === data?.Date) ? data?.Hour !== "" ? false : true : false,
                Holiday: allHolidays.find((holiday) => moment(holiday?.Date).format("YYYY-MM-DD") === data?.Date) ? allHolidays.find((holiday) => moment(holiday?.Date).format("YYYY-MM-DD") === data?.Date)?.Name : ""
            }))
        }))

        const updatedSequenceData = processFavorites(isHolidayCheck);

        const finalHolidayCheck = updatedSequenceData?.map((seq) => ({
            ...seq,
            seqArray: seq?.seqArray?.map((data) => ({
                ...data,
                // Hour: allHolidays.find((holiday) => moment(holiday?.Date).format("YYYY-MM-DD") === data?.Date) ? "" : data?.Hour,
                IsHoliday: allHolidays.find((holiday) => moment(holiday?.Date).format("YYYY-MM-DD") === data?.Date) ? data?.Hour !== "" ? false : true : false,
                Holiday: allHolidays.find((holiday) => moment(holiday?.Date).format("YYYY-MM-DD") === data?.Date) ? allHolidays.find((holiday) => moment(holiday?.Date).format("YYYY-MM-DD") === data?.Date)?.Name : ""
            }))
        }))

        setSequenceData(finalHolidayCheck?.filter(item =>
            item.seqArray.some(seq => seq.User === (currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === userUpnPa)?.UPN)
        ));

    }, [allTimesheets, weekDates, currentUser?.Data?.Email, allFourites])

    const processFavorites = (data) => {

        const favoriteData = data?.filter(a => a?.seqArray?.every(a => a?.IsFavourite));

        if (!disableCondition1 && allFourites.length > 0) {
            const maxSequence = Math.max(...data?.map(a => a?.Sequence), 0);
            const addedFavorite = allFourites.map((fav, i) => {
                const newSequence = maxSequence + 1 + i;
                return {
                    Sequence: newSequence,
                    IsMobile: false,
                    seqArray: weekDates?.map((date, dateIndex) => {
                        const referenceData = data[0]?.seqArray[dateIndex] || {};
                        return {
                            Comment: "",
                            Date: date,
                            FunctionId: fav?.FunctionId,
                            Hour: "",
                            IsMobile: false,
                            Hours: "00:00:00",
                            Id: 0,
                            IndexId: dateIndex,
                            IsSubmited: referenceData?.IsSubmited ?? false,
                            IsHoliday: allHolidays.find((holiday) => moment(holiday?.Date).format("YYYY-MM-DD") === date) ? data?.Hour !== "" ? false : true : false,
                            Holiday: referenceData?.Holiday ?? "",
                            ProjectId: fav?.ProjectId,
                            Sequence: newSequence,
                            ServiceCategoriesId: fav?.ServiceCategoriesId,
                            ServiceDisciplinesId: fav?.ServiceDisciplinesId,
                            User: currentUser?.Data?.PersonalAssistantManager?.find(u => u?.UPN === userUpnPa)?.UPN,
                            Notes: "",
                            IsFavourite: true
                        };
                    })
                };
            });

            const filteredFavorites = addedFavorite.every(f => f?.seqArray?.every(s => s?.IsSubmited)) ? [] : addedFavorite;


            const adjustedArray = filteredFavorites?.length > 0 && favoriteData?.length > 0
                ? filteredFavorites.map(favData => {
                    return favoriteData.find(dt => dt?.seqArray?.some(sd =>
                        favData?.seqArray?.some(fd =>
                            ['ProjectId', 'ServiceCategoriesId', 'ServiceDisciplinesId', 'FunctionId']
                                .every(key => sd?.[key] === fd?.[key]) && sd?.Hour
                        )
                    )) || favData
                })
                : filteredFavorites

            // console.log('data', data)
            // console.log('adjustedArray', adjustedArray)

            return [...(Array.isArray(adjustedArray) && adjustedArray.length ? adjustedArray : filteredFavorites), ...data.filter(a =>
                a?.seqArray?.some((a) =>
                    !adjustedArray?.some((f) =>
                        f?.seqArray?.some((newf) =>
                            newf?.Id === a?.Id
                            // && newf?.ServiceCategoriesId === a?.ServiceCategoriesId &&
                            // newf?.ServiceDisciplinesId === a?.ServiceDisciplinesId &&
                            // newf?.FunctionId === a?.FunctionId && !newf?.Hour
                        )
                    )
                )
            )];
        }

        return data;
    };


    // const processFavorites = (data) => {
    //     console.log('data', data)
    //     let haveToAddFavorite = allFourites?.filter(fav =>
    //         !data?.some(d =>
    //             d?.seqArray?.every(seq =>
    //                 seq?.ProjectId === fav?.ProjectId &&
    //                 seq?.ServiceCategoriesId === fav?.ServiceCategoriesId &&
    //                 seq?.ServiceDisciplinesId === fav?.ServiceDisciplinesId &&
    //                 seq?.FunctionId === fav?.FunctionId
    //             )
    //         )
    //     );
    //     console.log('haveToAddFavorite', haveToAddFavorite)
    //     const s = data?.filter((a) => a?.seqArray?.every((a) => a?.IsFavourite))

    //     if (!disableCondition1 && allFourites.length > 0) {
    //         const addedFavorite = allFourites?.map((fav, i) => {
    //             const newSequence = Math.max(...data?.map((a) => a?.Sequence)) + 1 + i;

    //             return {
    //                 Sequence: newSequence,
    //                 IsMobile: false,
    //                 seqArray: weekDates?.map((date, dateIndex) => ({
    //                     Comment: "",
    //                     Date: date,
    //                     FunctionId: fav?.FunctionId,
    //                     Hour: "",
    //                     IsMobile: false,
    //                     Hours: "00:00:00",
    //                     Id: 0,
    //                     IndexId: dateIndex,
    //                     IsSubmited: data[0]?.seqArray[dateIndex]?.IsSubmited ?? false,
    //                     IsHoliday: data[0]?.seqArray[dateIndex]?.IsHoliday ?? false,
    //                     Holiday: data[0]?.seqArray[dateIndex]?.Holiday ?? "",
    //                     ProjectId: fav?.ProjectId,
    //                     Sequence: newSequence,
    //                     ServiceCategoriesId: fav?.ServiceCategoriesId,
    //                     ServiceDisciplinesId: fav?.ServiceDisciplinesId,
    //                     User: (currentUser?.Data?.PersonalAssistantManager ?? []).find((u) => u?.UPN === userUpnPa)?.UPN,
    //                     Notes: "",
    //                     IsFavourite: true
    //                 })),
    //             };

    //         });

    //         const a = addedFavorite?.every((f) => f?.seqArray?.every((s) => s?.IsSubmited === true)) ? [] : addedFavorite
    //         console.log('s', s)
    //         console.log('a', a)
    //         const adjustedArray = a?.length > 0 && s?.length > 0 && a?.map((favData) => {
    //             if (s?.some((dt) => dt?.seqArray?.some((sd) =>
    //                 favData?.seqArray?.some((fd) =>
    //                     sd?.ProjectId === fd?.ProjectId &&
    //                     sd?.ServiceCategoriesId === fd?.ServiceCategoriesId &&
    //                     sd?.ServiceDisciplinesId === fd?.ServiceDisciplinesId &&
    //                     sd?.FunctionId === fd?.FunctionId && sd?.Hour
    //                 ))
    //             )) {

    //                 return s?.find((dt) => dt?.seqArray?.find((sd) =>
    //                     favData?.seqArray?.some((fd) =>
    //                         sd?.ProjectId === fd?.ProjectId &&
    //                         sd?.ServiceCategoriesId === fd?.ServiceCategoriesId &&
    //                         sd?.ServiceDisciplinesId === fd?.ServiceDisciplinesId &&
    //                         sd?.FunctionId === fd?.FunctionId && sd?.Hour
    //                     ))
    //                 )
    //             }
    //             return favData

    //         })

    //         console.log('adjustedArray', adjustedArray)

    //         console.log('a', a)
    //         return [...(typeof adjustedArray === "object" && adjustedArray?.length > 0 ? adjustedArray : a), ...data?.filter((a) => a?.seqArray?.every((a) => !a?.IsFavourite))];
    //     }

    //     return data;
    // };

    // const processFavorites = (data) => {
    //     const haveToAddFavorite = !allFourites.every((lItem) =>
    //         data.some((aItem) =>
    //             aItem.seqArray.every(
    //                 (seq) =>
    //                     seq.FunctionId === lItem.FunctionId &&
    //                     seq.ProjectId === lItem.ProjectId &&
    //                     seq.ServiceCategoriesId === lItem.ServiceCategoriesId &&
    //                     seq.ServiceDisciplinesId === lItem.ServiceDisciplinesId &&
    //                     seq.Hour === ""
    //             )
    //         )
    //     );
    //     if (!disableCondition1 && allFourites.length > 0 && haveToAddFavorite) {
    //         const addedFavorite = allFourites?.map((fav, i) => {
    //             const newSequence = Math.max(...data?.map((a) => a?.Sequence)) + 1 + i;

    //             return {
    //                 Sequence: newSequence,
    //                 IsMobile: false,
    //                 seqArray: weekDates?.map((date, dateIndex) => ({
    //                     Comment: "",
    //                     Date: date,
    //                     FunctionId: fav?.FunctionId,
    //                     Hour: "",
    //                     IsMobile: false,
    //                     Hours: "00:00:00",
    //                     Id: 0,
    //                     IndexId: dateIndex,
    //                     IsSubmited: data[0]?.seqArray[dateIndex]?.IsSubmited ?? false,
    //                     IsHoliday: data[0]?.seqArray[dateIndex]?.IsHoliday ?? false,
    //                     Holiday: data[0]?.seqArray[dateIndex]?.Holiday ?? "",
    //                     ProjectId: fav?.ProjectId,
    //                     Sequence: newSequence,
    //                     ServiceCategoriesId: fav?.ServiceCategoriesId,
    //                     ServiceDisciplinesId: fav?.ServiceDisciplinesId,
    //                     User: (currentUser?.Data?.PersonalAssistantManager ?? []).find((u) => u?.UPN === userUpnPa)?.UPN,
    //                     Notes: "",
    //                 })),
    //             };
    //         });

    //         const a = addedFavorite?.every((f) => f?.seqArray?.every((s) => s?.IsSubmited === true)) ? [] : addedFavorite

    //         return [...a, ...data];
    //     }

    //     return data;
    // };



    // Disable Conditions
    useEffect(() => {
        const allIsSubmitted = sequenceData?.every((seq) =>
            seq?.seqArray.every((week) => week?.IsSubmited)
        )

        const anyIsSubmitted = sequenceData?.some((seq) =>
            seq?.seqArray.some((week) => week?.IsSubmited)
        )

        const anyIsNotSubmitted = sequenceData?.some((seq) =>
            seq?.seqArray.some((week) => !week?.IsSubmited)
        )

        const dateRange = currentDateInRange()
        const submitMonth = moment(dateRange?.submitMonth, "MMMM").format("MM")
        const isSubmittedInMonth = sequenceData?.some((seq) =>
            seq?.seqArray.some((week) =>
                moment(week?.Date).format("MM") === submitMonth && week?.IsSubmited
            )
        )

        const sequenceLengthZeroDisable = sequenceData?.length > 0 ? true : false

        const lockedMonth = currentUser?.Data?.LockTimesheets?.length > 0 && currentUser?.Data?.LockTimesheets.some((period) => (
            moment(`${period?.Month}-${period?.Year}`, "MMM-YYYY").format("MM-YYYY") === moment(weekDates[0], "YYYY-MM-DD").format("MM-YYYY")
        ))

        const lockMonths = currentUser?.Data?.LockTimesheets?.length > 0 && currentUser?.Data?.LockTimesheets.map((period) => (
            moment(`${period?.Year}-${period?.Month}`, "YYYY-MMM").format("YYYY-MM")
        ))
        setLockedMonth(lockMonths.length > 0 ? lockMonths : [])

        const tempArray = sequenceData?.map((seq, seqIndex) => ({
            seq: seqIndex,
            isLocked: seq?.seqArray.some((day) =>
                day?.Hour !== ""
                    ? lockMonths.length > 0 ? lockMonths?.map((month) => moment(month, "YYYY-MMM").format("YYYY-MM") === moment(day?.Date, "YYYY-MM-DD").format("YYYY-MM")) : false
                    : false,
            ),
            weekDiffMonths: moment(seq?.seqArray[0]?.Date, "YYYY-MM-DD").format("YYYY-MM") !== moment(seq?.seqArray[6]?.Date, "YYYY-MM-DD").format("YYYY-MM")
        }))
        setNewDisableCondi(tempArray)

        setDisableCondition1(allIsSubmitted)
        setDisableCondition2(anyIsSubmitted)
        setDisableCondition3(isSubmittedInMonth)
        setDisableCondition4(sequenceLengthZeroDisable)
        setDisableCondition5(anyIsNotSubmitted)
        setLockPeriodDisableCondition(lockedMonth)
    }, [sequenceData])

    const checkIsProjectDisable = useCallback((data) => {
        if (data) {
            const isWeekSubmited = data?.hasOwnProperty("IsWeekSubmited")
            const isSameWeekDifferentMonth = newDisableCondi?.some((week) => week?.weekDiffMonths)
            if (isWeekSubmited) {
                if (isSameWeekDifferentMonth) {
                    return (
                        lockedMonth?.some((month) => month === moment(sequenceData[0]?.seqArray[0]?.Date, "YYYY-MM-DD").format("YYYY-MM")) === true
                        && lockedMonth?.some((month) => month === moment(sequenceData[0]?.seqArray[6]?.Date, "YYYY-MM-DD").format("YYYY-MM")) === true
                    )
                } else {
                    return data?.IsWeekSubmited || lockPeriodDisableCondition
                }
            } else {
                if (isSameWeekDifferentMonth) {
                    const lockedMonthsMatchedToEntryMonth = lockedMonth.length > 0 ? lockedMonth?.filter((month) =>
                        (data?.seqArray ?? [])?.some((date) => month === moment(date?.Date, "YYYY-MM-DD").format("YYYY-MM"))
                    ) : []
                    const isEntrysDateIsLockedHavingHour = !(data?.seqArray ?? [])?.every((date) => {
                        const isSameMonth = lockedMonthsMatchedToEntryMonth?.some((month) => month === moment(date?.Date, "YYYY-MM-DD").format("YYYY-MM"))
                        const value = ((isSameMonth && date?.Hour === "") || !isSameMonth)

                        return value
                    })

                    const submitedMonthsMatchedToEntryMonth = (submitedMonthArray ?? [])?.filter((month) =>
                        (data?.seqArray ?? [])?.some((date) => moment(month, "MMM").format("MM") === moment(date?.Date, "YYYY-MM-DD").format("MM"))
                    )
                    const isEntrysDateIsSubmitedHavingHour = !(data?.seqArray ?? [])?.every((date) => {
                        const isSameMonth = submitedMonthsMatchedToEntryMonth?.some((month) => month === moment(date?.Date, "YYYY-MM-DD").format("MMMM"))
                        const value = ((isSameMonth && date?.Hour === "") || !isSameMonth)

                        return value
                    })
                    return (isEntrysDateIsLockedHavingHour || isEntrysDateIsSubmitedHavingHour) ? (
                        disableCondition2 || lockPeriodDisableCondition
                    ) : (
                        false
                    )
                } else {
                    return disableCondition2 || lockPeriodDisableCondition
                }
            }
        }

        return true
    }, [disableCondition2, lockPeriodDisableCondition, lockedMonth, newDisableCondi, sequenceData, submitedMonthArray])

    const checkIsCopyDisable = useCallback((data) => {
        if (data) {
            const isWeekSubmited = data?.hasOwnProperty("IsWeekSubmited")
            const isSameWeekDifferentMonth = newDisableCondi?.some((week) => week?.weekDiffMonths)
            if (isWeekSubmited) {
                if (isSameWeekDifferentMonth) {
                    return (
                        lockedMonth?.some((month) => month === moment(sequenceData[0]?.seqArray[0]?.Date, "YYYY-MM-DD").format("YYYY-MM")) === true
                        && lockedMonth?.some((month) => month === moment(sequenceData[0]?.seqArray[6]?.Date, "YYYY-MM-DD").format("YYYY-MM")) === true
                    )
                } else {
                    return data?.IsWeekSubmited || lockPeriodDisableCondition
                }
            } else {
                if (isSameWeekDifferentMonth) {
                    const lockedMonthsMatchedToEntryMonth = lockedMonth.length > 0 ? lockedMonth.filter((month) =>
                        (data?.seqArray ?? [])?.some((date) => month === moment(date?.Date, "YYYY-MM-DD").format("YYYY-MM"))
                    ) : []
                    const isEntrysDateIsLockedHavingHour = !(data?.seqArray ?? [])?.every((date) => {
                        const isSameMonth = lockedMonthsMatchedToEntryMonth?.some((month) => month === moment(date?.Date, "YYYY-MM-DD").format("YYYY-MM"))
                        const value = ((isSameMonth && date?.Hour === "") || !isSameMonth)

                        return value
                    })

                    const submitedMonthsMatchedToEntryMonth = (submitedMonthArray ?? [])?.filter((month) =>
                        (data?.seqArray ?? [])?.some((date) => moment(month, "MMM").format("MM") === moment(date?.Date, "YYYY-MM-DD").format("MM"))
                    )
                    const isEntrysDateIsSubmitedHavingHour = !(data?.seqArray ?? [])?.every((date) => {
                        const isSameMonth = submitedMonthsMatchedToEntryMonth?.some((month) => month === moment(date?.Date, "YYYY-MM-DD").format("MMMM"))
                        const value = ((isSameMonth && date?.Hour === "") || !isSameMonth)

                        return value
                    })
                    return (isEntrysDateIsLockedHavingHour || isEntrysDateIsSubmitedHavingHour) ? (
                        disableCondition2 || lockPeriodDisableCondition
                    ) : (
                        false
                    )
                } else {
                    return disableCondition2 || lockPeriodDisableCondition
                }
            }
        }

        return true

        // -------- Old Disable Condition --------
        // const hasIsWeekSubmitedKey = data.hasOwnProperty("IsWeekSubmited")
        // const isSameWeekDifferentMonth = newDisableCondi?.some((week) => week?.weekDiffMonths)
        // if (hasIsWeekSubmitedKey) {
        //     if (isSameWeekDifferentMonth) {
        //         return (lockedMonth?.some((month) => month === moment(sequenceData[0]?.seqArray[0]?.Date, "YYYY-MM-DD").format("YYYY-MM")) === true
        //             && lockedMonth?.some((month) => month === moment(sequenceData[0]?.seqArray[6]?.Date, "YYYY-MM-DD").format("YYYY-MM")) === true)
        //     } else {
        //         return (disableCondition1 || lockPeriodDisableCondition)
        //     }
        // } else {
        //     return (disableCondition1 || lockPeriodDisableCondition)
        // }
    }, [disableCondition2, lockPeriodDisableCondition, lockedMonth, newDisableCondi, sequenceData, submitedMonthArray])

    const checkIsDeleteDisable = useCallback((data) => {
        if (data) {
            const isWeekSubmited = data?.hasOwnProperty("IsWeekSubmited")
            const isSameWeekDifferentMonth = newDisableCondi?.some((week) => week?.weekDiffMonths)
            if (isWeekSubmited) {
                if (isSameWeekDifferentMonth) {
                    return (
                        lockedMonth?.some((month) => month === moment(sequenceData[0]?.seqArray[0]?.Date, "YYYY-MM-DD").format("YYYY-MM")) === true
                        && lockedMonth?.some((month) => month === moment(sequenceData[0]?.seqArray[6]?.Date, "YYYY-MM-DD").format("YYYY-MM")) === true
                    )
                } else {
                    return data?.IsWeekSubmited || lockPeriodDisableCondition
                }
            } else {
                if (isSameWeekDifferentMonth) {
                    const lockedMonthsMatchedToEntryMonth = lockedMonth.length > 0 ? lockedMonth?.filter((month) =>
                        (data?.seqArray ?? [])?.some((date) => month === moment(date?.Date, "YYYY-MM-DD").format("YYYY-MM"))
                    ) : []
                    const isEntrysDateIsLockedHavingHour = !(data?.seqArray ?? [])?.every((date) => {
                        const isSameMonth = lockedMonthsMatchedToEntryMonth?.some((month) => month === moment(date?.Date, "YYYY-MM-DD").format("YYYY-MM"))
                        const value = ((isSameMonth && date?.Hour === "") || !isSameMonth)

                        return value
                    })

                    const submitedMonthsMatchedToEntryMonth = (submitedMonthArray ?? [])?.filter((month) =>
                        (data?.seqArray ?? [])?.some((date) => moment(month, "MMM").format("MM") === moment(date?.Date, "YYYY-MM-DD").format("MM"))
                    )
                    const isEntrysDateIsSubmitedHavingHour = !(data?.seqArray ?? [])?.every((date) => {
                        const isSameMonth = submitedMonthsMatchedToEntryMonth?.some((month) => month === moment(date?.Date, "YYYY-MM-DD").format("MMMM"))
                        const value = ((isSameMonth && date?.Hour === "") || !isSameMonth)

                        return value
                    })
                    return (isEntrysDateIsLockedHavingHour || isEntrysDateIsSubmitedHavingHour) ? (
                        disableCondition2 || lockPeriodDisableCondition
                    ) : (
                        false
                    )
                } else {
                    return disableCondition2 || lockPeriodDisableCondition
                }
            }
        }

        return true

        // -------- Old Disable Condition --------
        // data.hasOwnProperty("IsWeekSubmited")
        // ? (newDisableCondi?.some((week) => week?.weekDiffMonths)
        //     ? (lockedMonth?.some((month) => month === moment(sequenceData[0]?.seqArray[0]?.Date, "YYYY-MM-DD").format("YYYY-MM")) === true
        //         && lockedMonth?.some((month) => month === moment(sequenceData[0]?.seqArray[6]?.Date, "YYYY-MM-DD").format("YYYY-MM")) === true)
        //     : (data?.IsWeekSubmited || lockPeriodDisableCondition))
        // : (disableCondition2 || lockPeriodDisableCondition)
    }, [disableCondition2, lockPeriodDisableCondition, lockedMonth, newDisableCondi, sequenceData, submitedMonthArray])

    const checkIsAddNewRowDisable = useCallback(() => {
        const isSameWeekDifferentMonth = newDisableCondi?.some((week) => week?.weekDiffMonths)
        if (isSameWeekDifferentMonth) {
            return (lockedMonth.length > 0 && lockedMonth?.some((month) => month === moment(sequenceData[0]?.seqArray[0]?.Date, "YYYY-MM-DD").format("YYYY-MM")) === true
                && lockedMonth?.some((month) => month === moment(sequenceData[0]?.seqArray[6]?.Date, "YYYY-MM-DD").format("YYYY-MM")) === true)
                || (submitedMonthArray.length > 0 && submitedMonthArray?.some((month) => moment(month, "MMMM").format("MM") === moment(sequenceData[0]?.seqArray[0]?.Date, "YYYY-MM-DD").format("MM")) === true
                    && submitedMonthArray?.some((month) => moment(month, "MMMM").format("MM") === moment(sequenceData[0]?.seqArray[6]?.Date, "YYYY-MM-DD").format("MM")) === true)
        } else {
            return (disableCondition1 || lockPeriodDisableCondition) && disableCondition4
        }
    }, [disableCondition1, disableCondition4, lockPeriodDisableCondition, lockedMonth, newDisableCondi, sequenceData, submitedMonthArray])

    const checkIsSaveDisable = useCallback(() => {
        const isSameWeekDifferentMonth = newDisableCondi?.some((week) => week?.weekDiffMonths)
        if (isSameWeekDifferentMonth) {
            return (lockedMonth.length > 0 && lockedMonth?.some((month) => month === moment(sequenceData[0]?.seqArray[0]?.Date, "YYYY-MM-DD").format("YYYY-MM")) === true
                && lockedMonth?.some((month) => month === moment(sequenceData[0]?.seqArray[6]?.Date, "YYYY-MM-DD").format("YYYY-MM")) === true)
                || (submitedMonthArray.length > 0 && submitedMonthArray?.some((month) => moment(month, "MMMM").format("MM") === moment(sequenceData[0]?.seqArray[0]?.Date, "YYYY-MM-DD").format("MM")) === true
                    && submitedMonthArray?.some((month) => moment(month, "MMMM").format("MM") === moment(sequenceData[0]?.seqArray[6]?.Date, "YYYY-MM-DD").format("MM")) === true)
        } else {
            return disableCondition1 || lockPeriodDisableCondition
        }
    }, [disableCondition1, lockPeriodDisableCondition, lockedMonth, newDisableCondi, sequenceData, submitedMonthArray])

    const timesheetPeriodDisable = (date) => {
        return currentUser?.Data?.LockTimesheets?.length > 0 && currentUser?.Data?.LockTimesheets.some((period) => (
            moment(`${period?.Month}-${period?.Year}`, "MMM-YYYY").format("MM-YYYY") === moment(date, "YYYY-MM-DD").format("MM-YYYY")
        ))
    }

    const handleEnableHoliday = (timesheet) => {
        const tempArray = sequenceData?.map((seq) => ({
            ...seq,
            seqArray: seq?.seqArray?.map((data) => ({
                ...data,
                IsHoliday: timesheet?.Sequence === seq?.Sequence && timesheet?.Date === data?.Date ? false : data?.IsHoliday
            }))
        }))
        setSequenceData(tempArray)
    }

    // submited months array
    const checkSubmitedMonths = (months) => {
        if (months !== null && months !== "") {
            const monthArray = months.split(",")
            setSubmitedMonthArray(monthArray)
        } else {
            setSubmitedMonthArray([])
        }
    }

    // Calculate total time date-wise
    const totalTimeByDate = sequenceData?.reduce((result, { seqArray }) => {
        seqArray?.forEach(({ Date, Hour }) => {
            // Convert blank strings to 0
            const hour = Hour === "" ? 0 : parseFloat(Hour);

            const dateEntry = result.find(entry => entry.Date === Date);
            if (dateEntry) {
                dateEntry.TotalTime += hour;
            } else {
                result.push({ Date, TotalTime: hour });
            }
        });
        return result;
    }, [])

    // Calculate total time date-wise
    const totalTimeByDateCopyModal = sequenceCheckData?.reduce((result, { seqArray }) => {
        seqArray?.forEach(({ Date, Hour }) => {
            // Convert blank strings to 0
            const hour = Hour === "" ? 0 : parseFloat(Hour);

            const dateEntry = result.find(entry => entry.Date === Date);
            if (dateEntry) {
                dateEntry.TotalTime += hour;
            } else {
                result.push({ Date, TotalTime: hour });
            }
        });
        return result;
    }, [])

    // Calculate week total time
    const totalOfTotalTime = totalTimeByDate?.reduce((total, { TotalTime }) => total + TotalTime, 0);

    // Copy Sequence
    const handleOnClickCopy = (seqArray, IsWeekSubmited) => {
        if (seqArray[0]?.FunctionId !== 0 && seqArray[0]?.ServiceCategoriesId !== 0 && seqArray[0]?.ServiceDisciplinesId !== 0 &&
            (allServiceCategories?.filter((cate) => cate?.Id === seqArray[0]?.ServiceCategoriesId)[0]?.ProjectSelection ? seqArray[0]?.ProjectId !== 0 : true)) {
            setSequenceData([
                ...sequenceData,
                {
                    Sequence: Math.max(...removeDupe(sequenceData)) + 1,
                    IsMobile: false,
                    IsWeekSubmited: IsWeekSubmited,
                    seqArray: seqArray?.map((data) => ({
                        ...data,
                        Id: 0,
                        Hour: data?.IsSubmited ? "" : data?.Hour,
                        Sequence: Math.max(...removeDupe(sequenceData)) + 1,
                        IsSubmited: data?.IsSubmited
                    }))
                }
            ])
            let tempArray = [
                ...allTimesheetsResponse,
                ...seqArray?.map((d) => ({
                    "Id": 0,
                    "Date": d?.Date,
                    "Hour": d?.IsSubmited ? "" : d?.Hour,
                    "ProjectId": d?.ProjectId,
                    "ServiceCategoriesId": d?.ServiceCategoriesId,
                    "ServiceDisciplinesId": d?.ServiceDisciplinesId,
                    "FunctionId": d?.FunctionId,
                    "Comment": d?.Comment,
                    "IsSubmited": d?.IsSubmited,
                    "Sequence": Math.max(...removeDupe(sequenceData)) + 1,
                    "User": d?.User,
                    "IsMobile": d?.IsMobile,
                    "Notes": d?.Notes
                }))
            ]
            setAllTimesheetsResponse(tempArray?.filter((d) => d?.Hour !== ""))
            saveWeekData(tempArray?.filter((d) => d?.Hour !== ""))
            setCheckAllTimesheets(tempArray?.filter((d) => d?.Hour !== ""))
        } else {
            if (seqArray[0]?.FunctionId === 0) {
                toast.error("Function is required!")
            } else if (seqArray[0]?.ServiceCategoriesId === 0) {
                toast.error("Service Categories is required!")
            } else if (seqArray[0]?.ServiceDisciplinesId === 0) {
                toast.error("Service Disciplines is required!")
            } else if (allServiceCategories?.filter((cate) => cate?.Id === seqArray[0]?.ServiceCategoriesId)[0]?.ProjectSelection && seqArray[0]?.ProjectId === 0) {
                toast.error("Project is required!")
            }
        }
    }

    // Delete Sequence
    const handleOnClickDelete = async (data) => {
        setIsLoading(true)

        let payload = [];
        data?.seqArray.forEach((e) => {
            if (e?.Id !== 0) {
                payload.push(e?.Id);
            }
        });

        if (payload.length > 0) {
            swal({
                title: 'Are you sure?',
                text: 'You will not be able to recover this timesheet!',
                icon: 'warning',
                buttons: ['Cancel', 'Yes, delete it!'],
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    deleteTimeSheet(payload).then((response) => {
                        if (response?.Success) {
                            toast.success("Timesheet deleted successfully")
                            GetAllTimesheets(userUpnPa && (currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === userUpnPa)?.UPN)
                        }
                    }).catch((error) => {
                        console.warn("error", error)
                    }).finally(() => {
                        setIsLoading(false)
                    });
                } else {
                    setIsLoading(false);
                }
            });
        } else {
            setSequenceData(sequenceData?.filter((seq) => seq?.Sequence !== data?.Sequence))
            setAllTimesheetsResponse(allTimesheetsResponse?.filter((seq) => seq?.Sequence !== data?.Sequence))
            setCheckAllTimesheets(allTimesheetsResponse?.filter((seq) => seq?.Sequence !== data?.Sequence))
            setIsLoading(false)
        }
    }

    // Add New Row
    const handleOnClickAddRow = () => {
        const tempSequence = [
            ...sequenceData,
            {
                Sequence: sequenceData.length > 0 ? Math.max(...removeDupe(sequenceData)) + 1 : 1,
                IsMobile: false,
                IsWeekSubmited: weekDates?.map((date, dateIndex) => {
                    return {
                        Comment: null,
                        Date: date,
                        FunctionId: 0,
                        Hour: "",
                        Hours: "00:00:00",
                        IsMobile: false,
                        Id: 0,
                        IndexId: dateIndex,
                        IsSubmited: false,
                        Notes: "",
                        ProjectId: 0,
                        Sequence: sequenceData.length > 0 ? Math.max(...removeDupe(sequenceData)) + 1 : 1,
                        ServiceCategoriesId: 0,
                        ServiceDisciplinesId: 0,
                        User: (currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === userUpnPa)?.UPN,
                    }
                }).some(entry => !entry.IsSubmited) ? false : true,
                seqArray: weekDates?.map((date, dateIndex) => {
                    return {
                        Comment: null,
                        Date: date,
                        FunctionId: 0,
                        Hour: "",
                        Hours: "00:00:00",
                        IsMobile: false,
                        Id: 0,
                        IndexId: dateIndex,
                        IsSubmited: submitedMonthArray?.some((month) => moment(month, "MMM").format("MM") === moment(date, "YYYY-MM-DD").format("MM")) ? true : false,
                        Notes: "",
                        ProjectId: 0,
                        Sequence: sequenceData.length > 0 ? Math.max(...removeDupe(sequenceData)) + 1 : 1,
                        ServiceCategoriesId: 0,
                        ServiceDisciplinesId: 0,
                        User: (currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === userUpnPa)?.UPN,
                    }
                })
            }
        ]

        const submitedMonth = tempSequence?.map((seq) => ({
            ...seq,
            seqArray: seq?.seqArray?.map((data) => ({
                ...data,
                IsSubmited: submitedMonthArray?.length > 0
                    ? submitedMonthArray?.map((month) => moment(month, "MMMM").format("MM") === moment(data?.Date, "YYYY-MM-DD").format("MM"))[0]
                        ? true
                        : false
                    : false
            }))
        }))

        const isHolidayCheck = submitedMonth?.map((seq) => ({
            ...seq,
            seqArray: seq?.seqArray?.map((data) => ({
                ...data,
                // Hour: allHolidays.find((holiday) => moment(holiday?.Date).format("YYYY-MM-DD") === data?.Date) ? "" : data?.Hour,
                IsHoliday: allHolidays.find((holiday) => moment(holiday?.Date).format("YYYY-MM-DD") === data?.Date) ? data?.Hour !== "" ? false : true : false,
                Holiday: allHolidays.find((holiday) => moment(holiday?.Date).format("YYYY-MM-DD") === data?.Date) ? allHolidays.find((holiday) => moment(holiday?.Date).format("YYYY-MM-DD") === data?.Date)?.Name : ""
            }))
        }))

        const defaultHolidayDataSet = isHolidayCheck.map((item) => ({
            ...item,
            DefaultHoliday: item.seqArray.some(seqItem => seqItem.IsHoliday),
            seqArray: item.seqArray.map((data) => ({
                ...data,
                FunctionId: item.hasOwnProperty("IsWeekSubmited") ? item.seqArray.some(seqItem => seqItem.IsHoliday) ? defaultHolidaySelection?.FunctionId : data?.FunctionId : data?.FunctionId,
                ServiceCategoriesId: item.hasOwnProperty("IsWeekSubmited") ? item.seqArray.some(seqItem => seqItem.IsHoliday) ? defaultHolidaySelection?.ServiceCategoriesId : data?.ServiceCategoriesId : data?.ServiceCategoriesId,
                ServiceDisciplinesId: item.hasOwnProperty("IsWeekSubmited") ? item.seqArray.some(seqItem => seqItem.IsHoliday) ? defaultHolidaySelection?.ServiceDisciplinesId : data?.ServiceDisciplinesId : data?.ServiceDisciplinesId,
            }))
        }))

        setSequenceData(defaultHolidayDataSet)
    }

    // Open & Set Modal Data
    const handleSetData = (data) => {
        setInputSequence(data?.Sequence)
        setInputIsMobile(data?.IsMobile)
        setInputFunction(data?.seqArray[0]?.FunctionId)
        setInputServiceCategory(data?.seqArray[0]?.ServiceCategoriesId)
        setInputServiceDiscipline(data?.seqArray[0]?.ServiceDisciplinesId)
        setInputProject(data?.seqArray[0]?.ProjectId)
        setInputComment(data?.seqArray[0]?.Comment ?? "")
    }

    // Update Notes to sequenceData
    const handleSetNotes = () => {
        const array = sequenceData?.map((seq) => ({
            ...seq,
            seqArray: seq?.seqArray?.map((data) => ({
                ...data,
                Notes: inputSeqData?.Sequence === seq?.Sequence && inputSeqData?.IsMobile === seq?.IsMobile ? inputSeqData?.Date === data?.Date ? inputNotes : data?.Notes : data?.Notes
            }))
        }))
        setSequenceData(array)

        setAllTimesheetsResponse(
            allTimesheetsResponse?.map((prev) => {
                if (prev?.Id === inputSeqData?.Id) {
                    return ({
                        Comment: inputSeqData?.Comment,
                        Date: moment(inputSeqData?.Date).format("YYYY-MM-DD"),
                        FunctionId: inputSeqData?.FunctionId,
                        Hour: inputSeqData?.Hour,
                        Hours: inputSeqData?.Hours,
                        IsMobile: inputSeqData?.IsMobile,
                        Id: inputSeqData?.Id,
                        IsSubmited: inputSeqData?.IsSubmited,
                        ProjectId: inputSeqData?.ProjectId,
                        Sequence: inputSeqData?.Sequence,
                        ServiceCategoriesId: inputSeqData?.ServiceCategoriesId,
                        ServiceDisciplinesId: inputSeqData?.ServiceDisciplinesId,
                        User: (currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === userUpnPa)?.UPN,
                        Notes: inputNotes,
                        IsFavourite: inputSeqData?.IsFavourite ?? false
                    })
                } else {
                    return prev
                }
            })
        )

        setCheckAllTimesheets(
            allTimesheetsResponse?.map((prev) => {
                if (prev?.Id === inputSeqData?.Id) {
                    return ({
                        Comment: inputSeqData?.Comment,
                        Date: moment(inputSeqData?.Date).format("YYYY-MM-DD"),
                        FunctionId: inputSeqData?.FunctionId,
                        Hour: inputSeqData?.Hour,
                        Hours: inputSeqData?.Hours,
                        IsMobile: inputSeqData?.IsMobile,
                        Id: inputSeqData?.Id,
                        IsSubmited: inputSeqData?.IsSubmited,
                        ProjectId: inputSeqData?.ProjectId,
                        Sequence: inputSeqData?.Sequence,
                        ServiceCategoriesId: inputSeqData?.ServiceCategoriesId,
                        ServiceDisciplinesId: inputSeqData?.ServiceDisciplinesId,
                        User: (currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === userUpnPa)?.UPN,
                        Notes: inputNotes,
                        IsFavourite: inputSeqData?.IsFavourite ?? false
                    })
                } else {
                    return prev
                }
            })
        )

        AutoSaveTimeSheet({ ...inputSeqData, Notes: inputNotes })
    }

    // Input Time
    const handleOnTimeInput = (seqData, date, value) => {
        const regex = new RegExp(`^[0-9,.-]+$`)

        if (value?.length > 0) {
            if (regex.test(value)) {
                const array = sequenceData?.map((seq) => ({
                    ...seq,
                    seqArray: seq?.seqArray?.map((data) => ({
                        ...data,
                        Hour: seqData?.Sequence === seq?.Sequence && seqData?.IsMobile === seq?.IsMobile ? data?.Date === date ? value.length > 0 ? value.replace(",", ".") : "" : data?.Hour : data?.Hour
                    }))
                }))
                setSequenceData(array)
            }
        } else {
            const array = sequenceData?.map((seq) => ({
                ...seq,
                seqArray: seq?.seqArray?.map((data) => ({
                    ...data,
                    Hour: seqData?.Sequence === seq?.Sequence && seqData?.IsMobile === seq?.IsMobile ? data?.Date === date ? value.length === 0 ? 0 : "" : data?.Hour : data?.Hour
                }))
            }))
            setSequenceData(array)
        }
    }

    // Check value change
    const isValueChange = (timesheet) => {
        const data = allTimesheetsResponse?.filter((d) => d?.Sequence === timesheet?.Sequence && d?.Date === timesheet?.Date && d?.Hour === timesheet?.Hour)
        return data.length > 0 ? true : false
    }

    // Auto Save on Time Change
    const handleAutoSaveOnTimeChange = (timesheet, elementId) => {
        if (timesheet?.Hour !== "") {
            if (isValueChange(timesheet) === false) {

                const hasDot = timesheet?.Hour !== 0 ? timesheet?.Hour.includes(".") : false
                const hasComma = timesheet?.Hour !== 0 ? timesheet?.Hour.includes(",") : false

                if (timesheet?.Hour !== 0 && (hasDot || hasComma)) {
                    const time = timesheet?.Hour.split(hasDot ? "." : ",")
                    const Int = Number(time[0])
                    const Des = time[1]?.length > 0 ? Number(time[1]) : undefined

                    const isValidInt = Int >= 0 && Int <= 999
                    const isValidDes = Des !== undefined && time[1]?.toString()?.length <= 2
                    // const isValidDes = Des !== undefined && time[1]?.toString()?.length <= 2 && (Des === 0 || Des === 0o0 || Des === 25 || Des === 5 || Des === 50 || Des === 75)

                    if (isValidInt && isValidDes) {
                        AutoSaveTimeSheet(timesheet)
                    } else {
                        if (!isValidInt) {
                            toast.error("You can only enter upto 999")
                            const element = document.getElementById(elementId)
                            element && element?.focus()
                        } else {
                            toast.error("You can only enter upto 99 as decimals")
                            const element = document.getElementById(elementId)
                            element && element?.focus()
                        }
                    }
                } else {
                    if (timesheet?.Hour <= 999) {
                        AutoSaveTimeSheet(timesheet)
                    } else {
                        toast.error("You can only enter upto 999")
                        const element = document.getElementById(elementId)
                        element && element?.focus()
                    }
                }
            }
        }
    }

    const AutoSaveTimeSheet = async (timesheet,) => {
        let payload = {}

        if (timesheet?.Id === 0) {
            payload = {
                "Date": timesheet?.Date,
                "Hour": timesheet?.Hour !== 0 ? (timesheet?.Hour.includes(",") || timesheet?.Hour.includes(".")) ? timesheet?.Hour.replace(",", ".") : timesheet?.Hour : 0,
                "Hours": timesheet?.Hours,
                "IsMobile": timesheet?.IsMobile,
                "ProjectId": timesheet?.ProjectId,
                "ServiceCategoriesId": timesheet?.ServiceCategoriesId,
                "ServiceDisciplinesId": timesheet?.ServiceDisciplinesId,
                "FunctionId": timesheet?.FunctionId,
                "Comment": timesheet?.Comment,
                "IsSubmited": timesheet?.IsSubmited,
                "Sequence": timesheet?.Sequence,
                "User": timesheet?.User,
                "Notes": timesheet?.Notes,
                "IsFavourite": timesheet?.IsFavourite ?? false
            }
        } else {
            payload = {
                "Id": timesheet?.Id,
                "Date": timesheet?.Date,
                "Hour": timesheet?.Hour !== 0 ? (timesheet?.Hour.toString().includes(",") || timesheet?.Hour.toString().includes(".")) ? timesheet?.Hour.replace(",", ".") : timesheet?.Hour : 0,
                "Hours": timesheet?.Hours,
                "ProjectId": timesheet?.ProjectId,
                "ServiceCategoriesId": timesheet?.ServiceCategoriesId,
                "ServiceDisciplinesId": timesheet?.ServiceDisciplinesId,
                "FunctionId": timesheet?.FunctionId,
                "Comment": timesheet?.Comment,
                "IsSubmited": timesheet?.IsSubmited,
                "Sequence": timesheet?.Sequence,
                "User": timesheet?.User,
                "IsMobile": timesheet?.IsMobile,
                "Notes": timesheet?.Notes,
                "IsFavourite": timesheet?.IsFavourite ?? false
            }
        }

        if (payload?.FunctionId !== 0 && payload?.ServiceCategoriesId !== 0 && payload?.ServiceDisciplinesId !== 0 &&
            (allServiceCategories?.filter((cate) => cate?.Id === payload?.ServiceCategoriesId)[0]?.ProjectSelection ? payload?.ProjectId !== 0 : true)) {
            setIsAutoSaving(true)
            await createUpdateTimesheet(payload).then((response) => {
                if (response?.Success) {
                    const array = sequenceData?.map((seq) => ({
                        ...seq,
                        seqArray: seq?.seqArray?.map((data) => ({
                            ...data,
                            Comment: timesheet?.Sequence === seq?.Sequence && timesheet?.IsMobile === data?.IsMobile ? timesheet?.Date === data?.Date ? response?.Data?.Comment : data?.Comment : data?.Comment,
                            Date: timesheet?.Sequence === seq?.Sequence && timesheet?.IsMobile === data?.IsMobile ? timesheet?.Date === data?.Date ? moment(response?.Data?.Date).format("YYYY-MM-DD") : data?.Date : data?.Date,
                            FunctionId: timesheet?.Sequence === seq?.Sequence && timesheet?.IsMobile === data?.IsMobile ? data?.Date === timesheet?.Date ? response?.Data?.FunctionId : data?.FunctionId : data?.FunctionId,
                            Hour: timesheet?.Sequence === seq?.Sequence && timesheet?.IsMobile === data?.IsMobile ? data?.Date === timesheet?.Date ? response?.Data?.Hour : data?.Hour : data?.Hour,
                            Hours: timesheet?.Sequence === seq?.Sequence && timesheet?.IsMobile === data?.IsMobile ? data?.Date === timesheet?.Date ? response?.Data?.Hours : data?.Hours : data?.Hours,
                            IsMobile: timesheet?.Sequence === seq?.Sequence && timesheet?.IsMobile === data?.IsMobile ? data?.Date === timesheet?.Date ? response?.Data?.IsMobile : data?.IsMobile : data?.IsMobile,
                            Id: timesheet?.Sequence === seq?.Sequence && timesheet?.IsMobile === data?.IsMobile ? data?.Date === timesheet?.Date ? response?.Data?.Id : data?.Id : data?.Id,
                            IsSubmited: timesheet?.Sequence === seq?.Sequence && timesheet?.IsMobile === data?.IsMobile ? data?.Date === timesheet?.Date ? response?.Data?.IsSubmited : data?.IsSubmited : data?.IsSubmited,
                            ProjectId: timesheet?.Sequence === seq?.Sequence && timesheet?.IsMobile === data?.IsMobile ? data?.Date === timesheet?.Date ? response?.Data?.ProjectId : data?.ProjectId : data?.ProjectId,
                            Sequence: timesheet?.Sequence === seq?.Sequence && timesheet?.IsMobile === data?.IsMobile ? data?.Date === timesheet?.Date ? response?.Data?.Sequence : data?.Sequence : data?.Sequence,
                            ServiceCategoriesId: timesheet?.Sequence === seq?.Sequence && timesheet?.IsMobile === data?.IsMobile ? data?.Date === timesheet?.Date ? response?.Data?.ServiceCategoriesId : data?.ServiceCategoriesId : data?.ServiceCategoriesId,
                            ServiceDisciplinesId: timesheet?.Sequence === seq?.Sequence && timesheet?.IsMobile === data?.IsMobile ? data?.Date === timesheet?.Date ? response?.Data?.ServiceDisciplinesId : data?.ServiceDisciplinesId : data?.ServiceDisciplinesId,
                            User: timesheet?.Sequence === seq?.Sequence && timesheet?.IsMobile === data?.IsMobile ? data?.Date === timesheet?.Date ? response?.Data?.User : data?.User : data?.User,
                            Notes: timesheet?.Sequence === seq?.Sequence && timesheet?.IsMobile === data?.IsMobile ? data?.Date === timesheet?.Date ? response?.Data?.Notes : data?.Notes : data?.Notes,
                            IsFavourite: timesheet?.Sequence === seq?.Sequence && timesheet?.IsMobile === data?.IsMobile ? data?.Date === timesheet?.Date ? response?.Data?.IsFavourite : data?.IsFavourite : data?.IsFavourite ?? false,
                        }))
                    }))
                    setSequenceData(array)
                    toast.success("Data saved successfully!")

                    if (timesheet?.Id === 0) {
                        const getMatchedTimeSheet = (data) => {
                            return (
                                data?.Date === moment(response?.Data?.Date).format("YYYY-MM-DD") &&
                                data?.Sequence === response?.Data?.Sequence &&
                                data?.FunctionId === response?.Data?.FunctionId &&
                                data?.ServiceCategoriesId === response?.Data?.ServiceCategoriesId &&
                                data?.ServiceDisciplinesId === response?.Data?.ServiceDisciplinesId &&
                                data?.ProjectId === response?.Data?.ProjectId
                            )
                        }
                        const matchedTimeSheet = allTimesheetsResponse?.find((data) => getMatchedTimeSheet(data))
                        if (matchedTimeSheet) {
                            setAllTimesheetsResponse((prev) => (
                                (prev ?? [])?.map((data) => {
                                    if (getMatchedTimeSheet(data)) {
                                        return {
                                            ...matchedTimeSheet,
                                            Id: response?.Data?.Id,
                                            Hour: response?.Data?.Hour,
                                        }
                                    } else {
                                        return data
                                    }
                                })
                            ))
                        } else {
                            setAllTimesheetsResponse([
                                ...allTimesheetsResponse,
                                {
                                    Comment: response?.Data?.Comment,
                                    Date: moment(response?.Data?.Date).format("YYYY-MM-DD"),
                                    FunctionId: response?.Data?.FunctionId,
                                    Hour: response?.Data?.Hour,
                                    Hours: response?.Data?.Hours,
                                    IsMobile: response?.Data?.IsMobile,
                                    Id: response?.Data?.Id,
                                    IsSubmited: response?.Data?.IsSubmited,
                                    ProjectId: response?.Data?.ProjectId,
                                    Sequence: response?.Data?.Sequence,
                                    ServiceCategoriesId: response?.Data?.ServiceCategoriesId,
                                    ServiceDisciplinesId: response?.Data?.ServiceDisciplinesId,
                                    User: response?.Data?.User,
                                    Notes: response?.Data?.Notes,
                                    IsFavourite: response?.Data?.IsFavourite ?? false
                                }
                            ])
                        }
                        setCheckAllTimesheets([
                            ...allTimesheetsResponse,
                            {
                                Comment: response?.Data?.Comment,
                                Date: moment(response?.Data?.Date).format("YYYY-MM-DD"),
                                FunctionId: response?.Data?.FunctionId,
                                Hour: response?.Data?.Hour,
                                Hours: response?.Data?.Hours,
                                IsMobile: response?.Data?.IsMobile,
                                Id: response?.Data?.Id,
                                IsSubmited: response?.Data?.IsSubmited,
                                ProjectId: response?.Data?.ProjectId,
                                Sequence: response?.Data?.Sequence,
                                ServiceCategoriesId: response?.Data?.ServiceCategoriesId,
                                ServiceDisciplinesId: response?.Data?.ServiceDisciplinesId,
                                User: response?.Data?.User,
                                Notes: response?.Data?.Notes,
                                IsFavourite: response?.Data?.IsFavourite ?? false
                            }
                        ])
                    } else {
                        setAllTimesheetsResponse(
                            allTimesheetsResponse?.map((prev) => {
                                if (prev?.Id === response?.Data?.Id) {
                                    return ({
                                        Comment: response?.Data?.Comment,
                                        Date: moment(response?.Data?.Date).format("YYYY-MM-DD"),
                                        FunctionId: response?.Data?.FunctionId,
                                        Hour: response?.Data?.Hour,
                                        Hours: response?.Data?.Hours,
                                        IsMobile: response?.Data?.IsMobile,
                                        Id: response?.Data?.Id,
                                        IsSubmited: response?.Data?.IsSubmited,
                                        ProjectId: response?.Data?.ProjectId,
                                        Sequence: response?.Data?.Sequence,
                                        ServiceCategoriesId: response?.Data?.ServiceCategoriesId,
                                        ServiceDisciplinesId: response?.Data?.ServiceDisciplinesId,
                                        User: response?.Data?.User,
                                        Notes: response?.Data?.Notes,
                                        IsFavourite: response?.Data?.IsFavourite ?? false
                                    })
                                } else {
                                    return prev
                                }
                            })
                        )
                        setCheckAllTimesheets(
                            allTimesheetsResponse?.map((prev) => {
                                if (prev?.Id === response?.Data?.Id) {
                                    return ({
                                        Comment: response?.Data?.Comment,
                                        Date: moment(response?.Data?.Date).format("YYYY-MM-DD"),
                                        FunctionId: response?.Data?.FunctionId,
                                        Hour: response?.Data?.Hour,
                                        Hours: response?.Data?.Hours,
                                        IsMobile: response?.Data?.IsMobile,
                                        Id: response?.Data?.Id,
                                        IsSubmited: response?.Data?.IsSubmited,
                                        ProjectId: response?.Data?.ProjectId,
                                        Sequence: response?.Data?.Sequence,
                                        ServiceCategoriesId: response?.Data?.ServiceCategoriesId,
                                        ServiceDisciplinesId: response?.Data?.ServiceDisciplinesId,
                                        User: response?.Data?.User,
                                        Notes: response?.Data?.Notes,
                                        IsFavourite: response?.Data?.IsFavourite ?? false
                                    })
                                } else {
                                    return prev
                                }
                            })
                        )
                    }
                }
            }).catch((error) => {
                console.warn('error', error)
                toast.error(error)
            }).finally(() => {
                setIsAutoSaving(false)
            });
        } else {
            if (payload?.FunctionId === 0) {
                toast.error("Function is required!")
                const array = sequenceData?.map((seq) => ({
                    ...seq,
                    seqArray: seq?.seqArray?.map((data) => ({
                        ...data,
                        Hour: payload?.Sequence === seq?.Sequence && data?.Date === payload?.Date ? "" : data?.Hour
                    }))
                }))
                setSequenceData(array)
            } else if (payload?.ServiceCategoriesId === 0) {
                toast.error("Service Categories is required!")
                const array = sequenceData?.map((seq) => ({
                    ...seq,
                    seqArray: seq?.seqArray?.map((data) => ({
                        ...data,
                        Hour: payload?.Sequence === seq?.Sequence && data?.Date === payload?.Date ? "" : data?.Hour
                    }))
                }))
                setSequenceData(array)
            } else if (payload?.ServiceDisciplinesId === 0) {
                toast.error("Service Disciplines is required!")
                const array = sequenceData?.map((seq) => ({
                    ...seq,
                    seqArray: seq?.seqArray?.map((data) => ({
                        ...data,
                        Hour: payload?.Sequence === seq?.Sequence && data?.Date === payload?.Date ? "" : data?.Hour
                    }))
                }))
                setSequenceData(array)
            } else if (allServiceCategories?.filter((cate) => cate?.Id === payload?.ServiceCategoriesId)[0]?.ProjectSelection && payload?.ProjectId === 0) {
                toast.error("Project is required!")
                const array = sequenceData?.map((seq) => ({
                    ...seq,
                    seqArray: seq?.seqArray?.map((data) => ({
                        ...data,
                        Hour: payload?.Sequence === seq?.Sequence && data?.Date === payload?.Date ? "" : data?.Hour
                    }))
                }))
                setSequenceData(array)
            }
        }
    }

    const checkIsValidTime = (seqData) => {
        if (seqData?.Hour !== "") {
            if (isValueChange(seqData) === false) {

                const hasDot = seqData?.Hour.length > 0 && seqData?.Hour !== 0 ? seqData?.Hour.includes(".") : false
                const hasComma = seqData?.Hour.length > 0 && seqData?.Hour !== 0 ? seqData?.Hour.includes(",") : false

                if (seqData?.Hour !== 0 && (hasDot || hasComma)) {
                    const time = seqData?.Hour.split(hasDot ? "." : ",")
                    const Int = Number(time[0])
                    const Des = time[1]?.length > 0 ? Number(time[1]) : undefined

                    const isValidInt = Int >= 0 && Int <= 999
                    const isValidDes = Des !== undefined && time[1]?.toString()?.length <= 2
                    // const isValidDes = Des !== undefined && time[1]?.toString()?.length <= 2 && (Des === 0 || Des === 0o0 || Des === 25 || Des === 5 || Des === 50 || Des === 75)

                    if (isValidInt && isValidDes) {
                        return true
                    }
                    else {
                        if (!isValidInt) {
                            return false
                        } else {
                            return false
                        }
                    }
                } else {
                    if (seqData?.Hour <= 999) {
                        return true
                    } else {
                        return false
                    }
                }
            } else {
                return true
            }
        } else {
            return true
        }
    }

    // Save Modal Data
    const handleSaveData = () => {
        if (inputFunction !== 0 && inputServiceCategory !== 0 && inputServiceDiscipline !== 0 &&
            (allServiceCategories?.filter((cate) => cate?.Id === inputServiceCategory)[0]?.ProjectSelection ? inputProject !== 0 : true)) {
            const array = sequenceData?.map((seq) => ({
                ...seq,
                seqArray: seq?.seqArray?.map((data) => ({
                    ...data,
                    Comment: seq?.Sequence === inputSequence && seq?.IsMobile === inputIsMobile ? inputComment : data?.Comment,
                    FunctionId: seq?.Sequence === inputSequence && seq?.IsMobile === inputIsMobile ? inputFunction : data?.FunctionId,
                    ServiceCategoriesId: seq?.Sequence === inputSequence && seq?.IsMobile === inputIsMobile ? inputServiceCategory : data?.ServiceCategoriesId,
                    ServiceDisciplinesId: seq?.Sequence === inputSequence && seq?.IsMobile === inputIsMobile ? inputServiceDiscipline : data?.ServiceDisciplinesId,
                    ProjectId: seq?.Sequence === inputSequence && seq?.IsMobile === inputIsMobile ? inputProject : data?.ProjectId
                }))
            }))
            setSequenceData(array)

            const tempArray = allTimesheetsResponse?.map((data) => ({
                ...data,
                Comment: data?.Sequence === inputSequence && data?.IsMobile === inputIsMobile ? inputComment : data?.Comment,
                FunctionId: data?.Sequence === inputSequence && data?.IsMobile === inputIsMobile ? inputFunction : data?.FunctionId,
                ServiceCategoriesId: data?.Sequence === inputSequence && data?.IsMobile === inputIsMobile ? inputServiceCategory : data?.ServiceCategoriesId,
                ServiceDisciplinesId: data?.Sequence === inputSequence && data?.IsMobile === inputIsMobile ? inputServiceDiscipline : data?.ServiceDisciplinesId,
                ProjectId: data?.Sequence === inputSequence && data?.IsMobile === inputIsMobile ? inputProject : data?.ProjectId
            }))
            setAllTimesheetsResponse(tempArray)
            setCheckAllTimesheets(tempArray)
        } else {
            if (inputFunction === 0) {
                toast.error("Function is required!")
            } else if (inputServiceCategory === 0) {
                toast.error("Service Categories is required!")
            } else if (inputServiceDiscipline === 0) {
                toast.error("Service Disciplines is required!")
            } else if (allServiceCategories?.filter((cate) => cate?.Id === inputServiceCategory)[0]?.ProjectSelection && inputProject === 0) {
                toast.error("Project is required!")
            }
        }
    }

    // Save Week Data
    const saveWeekData = async (weekData) => {
        const payload = weekData ?? (allTimesheetsResponse ?? [])?.filter((d) => d?.Hour !== "")

        if (payload?.length > 0) {
            var temp = [];

            payload?.some((data) => {
                const category = allServiceCategories?.find((cate) => cate?.Id === data?.ServiceCategoriesId);

                const isProjectValid = category?.ProjectSelection
                    ? (data?.ProjectId !== 0)
                    : true;

                // Return the combined condition
                temp.push(data?.FunctionId !== 0 &&
                    data?.ServiceCategoriesId !== 0 &&
                    data?.ServiceDisciplinesId !== 0 &&
                    isProjectValid)
            })

            if (temp?.some((d) => d === false) ? false : true) {
                const isValid = (sequenceData ?? [])?.map((d) => !(d?.seqArray ?? [])?.some((s) => !checkIsValidTime(s)))

                if (!isValid?.some((v) => !v)) {
                    setIsLoading(true)
                    const response = await insertUpdateTimesheets(payload)
                    if (typeof response?.Data === "object" && response?.Success) {
                        await GetAllTimesheets(userUpnPa && (currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === userUpnPa)?.UPN)
                        toast.success("Data saved successfully!")
                    } else {
                        toast.error(response?.ExceptionMessage ?? response?.Message ?? response ?? "Get All Timesheets Error")
                    }
                    setIsLoading(false)
                } else {
                    toast.error("Please enter Hour integer upto 999 and decimal upto 99!")
                }
            } else {
                toast.error("Project is missing in some tasks!")
            }
        } else {
            toast.error("No data to save!")
        }
        setShouldCallSave(false)

        return
    }

    useEffect(() => {
        if (shouldCallSave && !isAutoSaving) {
            saveWeekData()
        }
    }, [isAutoSaving, shouldCallSave])

    // Submit Week Data
    const submitWeekData = () => {
        const startOfMonth = moment(weekDates[0]).startOf('month').format('YYYY-MM-DD');
        const endOfMonth = moment(weekDates[0]).endOf('month').format('YYYY-MM-DD');

        const payload = {
            "StartDate": startOfMonth,
            "EndDate": endOfMonth,
            "User": (currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === userUpnPa)?.UPN
        }

        swal({
            title: "Are you sure?",
            text: "You will not be able to unsubmit this timesheets!",
            icon: "warning",
            buttons: ['Cancel', 'Yes, submit it!'],
            className: "custom-swal",
            successMode: true,
        }).then((willSubmit) => {
            if (willSubmit) {
                setIsLoading(true);
                submitTimesheet(payload).then((response) => {
                    if (typeof response?.Data === "object" && response?.Success) {
                        toast.success("Data saved successfully!")
                        GetAllTimesheets(userUpnPa && (currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === userUpnPa)?.UPN)
                    } else {
                        toast.error(response?.Message)
                    }
                }).catch((error) => {
                    console.warn('error', error)
                }).finally(() => {
                    setIsLoading(false)
                });
            }
        })
    }

    // Keep watch on window width
    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth <= 480);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleDateChange = (direction) => {
        setTooltipVisible({})
        if (direction === "prev") {
            setCalendarDate((prev) => moment(prev).subtract(isMobileView ? 1 : 7, "d").format("YYYY-MM-DD"));
        } else if (direction === "next") {
            setCalendarDate((prev) => moment(prev).add(isMobileView ? 1 : 7, "d").format("YYYY-MM-DD"));
        } else {
            setCalendarDate(moment()._d);
        }
    };

    const CustomDatePicker = forwardRef(({ value, onClick }, ref) =>
        <div className="cal-icon">
            <button type="submit" onClick={onClick} ref={ref} className="btn btn-primary-w btn-icon2 cal-btn p-3">
                <i className="fa-regular fa-calendar" />
            </button>
        </div>
    );

    const scrollToDiv = () => {
        var main = document.getElementById("pagetitle");
        main && main?.scrollIntoView({ behavior: "smooth", block: "end" });
    }

    // Show/Hide submit button
    const currentDateInRange = () => {
        const endOfMonth = moment(weekDates[0]).endOf('month').format('YYYY-MM-DD');
        const month = moment(endOfMonth, 'YYYY-MM-DD').format('MMMM');

        return { submitShow: weekDates?.find((date) => date === endOfMonth) ? true : false, submitMonth: month }
    }

    // used in change on copy from modal
    const CurrentWeek = () => {
        let dates = []

        const weekStart = isMobileView
            ? moment(checkDate).format("YYYY-MM-DD")
            : moment(checkDate).startOf("isoWeek").format("YYYY-MM-DD")
        Array.from(Array(isMobileView ? 1 : 7), (_, i) => i + 1)?.forEach((_, i) => {
            dates.push(moment(weekStart).add(i, "d").format("YYYY-MM-DD"))
        })

        setCurrentWeek(dates)
    }

    // dates for copy from modal 
    const weekCheckDates = useMemo(() => {
        let dates = []

        const weekStart = isMobileView
            ? moment(checkDate).format("YYYY-MM-DD")
            : moment(checkDate).startOf("isoWeek").format("YYYY-MM-DD")
        Array.from(Array(isMobileView ? 1 : 7), (_, i) => i + 1)?.forEach((_, i) => {
            dates.push(moment(weekStart).add(i, "d").format("YYYY-MM-DD"))
        })

        return dates
    }, [checkDate, isMobileView])

    // timesheet for copy from modal
    useEffect(() => {
        let sequenceDateData = []

        removeDupe(checkAllTimesheets)?.forEach((d, index) => {
            const currentSequenceTotalArray = checkAllTimesheets?.filter((timeSheet) => timeSheet?.Sequence === d)
            const isMobileTrueArray = currentSequenceTotalArray?.filter((timeSheet) => timeSheet?.IsMobile)
            const isMobileFalseArray = currentSequenceTotalArray?.filter((timeSheet) => !timeSheet?.IsMobile)

            if (checkAllTimesheets.length > 0) {
                if (isMobileTrueArray?.length > 0) {
                    sequenceDateData.push({
                        Sequence: d,
                        IsMobile: true,
                        seqArray: weekCheckDates?.map((date, dateIndex) => {
                            const defaultData = checkAllTimesheets?.filter((timeSheet) => timeSheet?.IsMobile)?.find((timesheet) => timesheet?.Sequence === d)
                            const data = checkAllTimesheets?.filter((timeSheet) => timeSheet?.IsMobile)?.find((timesheet) =>
                                timesheet?.Sequence === d &&
                                timesheet?.Date === date
                            )

                            return data ? (
                                data
                            ) : checkAllTimesheets?.filter((timeSheet) => timeSheet?.IsMobile).length > 0 ? {
                                ...defaultData,
                                Id: 0,
                                Hour: "",
                                Date: date,
                                IndexId: dateIndex,
                                Notes: ""
                            } : allFourites[index]
                                ? ({
                                    Comment: "",
                                    Date: date,
                                    FunctionId: allFourites[index]?.FunctionId,
                                    Hour: "",
                                    Id: 0,
                                    IndexId: dateIndex,
                                    IsSubmited: false,
                                    ProjectId: allFourites[index]?.ProjectId,
                                    Sequence: d,
                                    ServiceCategoriesId: allFourites[index]?.ServiceCategoriesId,
                                    ServiceDisciplinesId: allFourites[index]?.ServiceDisciplinesId,
                                    User: (currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === userUpnPa)?.UPN,
                                    Notes: ""
                                }) : ({
                                    Comment: "",
                                    Date: date,
                                    FunctionId: 0,
                                    Hour: "",
                                    Id: 0,
                                    IndexId: dateIndex,
                                    IsSubmited: false,
                                    ProjectId: 0,
                                    Sequence: 1,
                                    ServiceCategoriesId: 0,
                                    ServiceDisciplinesId: 0,
                                    User: (currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === userUpnPa)?.UPN,
                                    Notes: ""
                                })
                        })
                    })
                }

                if (isMobileFalseArray?.length > 0) {
                    sequenceDateData.push({
                        Sequence: d,
                        IsMobile: false,
                        seqArray: weekCheckDates?.map((date, dateIndex) => {
                            const defaultData = checkAllTimesheets?.filter((timeSheet) => !timeSheet?.IsMobile)?.find((timesheet) => timesheet?.Sequence === d)
                            const data = checkAllTimesheets?.filter((timeSheet) => !timeSheet?.IsMobile)?.find((timesheet) =>
                                timesheet?.Sequence === d &&
                                timesheet?.Date === date
                            )

                            return data ? (
                                data
                            ) : checkAllTimesheets?.filter((timeSheet) => !timeSheet?.IsMobile).length > 0 ? {
                                ...defaultData,
                                Id: 0,
                                Hour: "",
                                Date: date,
                                IndexId: dateIndex,
                                Notes: ""
                            } : allFourites[index]
                                ? ({
                                    Comment: "",
                                    Date: date,
                                    FunctionId: allFourites[index]?.FunctionId,
                                    Hour: "",
                                    Id: 0,
                                    IndexId: dateIndex,
                                    IsSubmited: false,
                                    ProjectId: allFourites[index]?.ProjectId,
                                    Sequence: d,
                                    ServiceCategoriesId: allFourites[index]?.ServiceCategoriesId,
                                    ServiceDisciplinesId: allFourites[index]?.ServiceDisciplinesId,
                                    User: (currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === userUpnPa)?.UPN,
                                    Notes: ""
                                }) : ({
                                    Comment: "",
                                    Date: date,
                                    FunctionId: 0,
                                    Hour: "",
                                    Id: 0,
                                    IndexId: dateIndex,
                                    IsSubmited: false,
                                    ProjectId: 0,
                                    Sequence: 1,
                                    ServiceCategoriesId: 0,
                                    ServiceDisciplinesId: 0,
                                    User: (currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === userUpnPa)?.UPN,
                                    Notes: ""
                                })
                        })
                    })
                }
            } else {
                sequenceDateData.push({
                    Sequence: d,
                    IsMobile: false,
                    seqArray: weekCheckDates?.map((date, dateIndex) => {
                        const defaultData = checkAllTimesheets?.find((timesheet) => timesheet?.Sequence === d)
                        const data = checkAllTimesheets?.find((timesheet) =>
                            timesheet?.Sequence === d &&
                            timesheet?.Date === date
                        )

                        return data ? (
                            data
                        ) : checkAllTimesheets.length > 0 ? {
                            ...defaultData,
                            Id: 0,
                            Hour: "",
                            Date: date,
                            IndexId: dateIndex,
                            Notes: ""
                        } : allFourites[index] ? ({
                            Comment: "",
                            Date: date,
                            FunctionId: allFourites[index]?.FunctionId,
                            Hour: "",
                            Id: 0,
                            IndexId: dateIndex,
                            IsSubmited: false,
                            ProjectId: allFourites[index]?.ProjectId,
                            Sequence: d,
                            ServiceCategoriesId: allFourites[index]?.ServiceCategoriesId,
                            ServiceDisciplinesId: allFourites[index]?.ServiceDisciplinesId,
                            User: (currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === userUpnPa)?.UPN,
                            Notes: ""
                        }) : ({
                            Comment: "",
                            Date: date,
                            FunctionId: 0,
                            Hour: "",
                            Id: 0,
                            IndexId: dateIndex,
                            IsSubmited: false,
                            ProjectId: 0,
                            Sequence: 1,
                            ServiceCategoriesId: 0,
                            ServiceDisciplinesId: 0,
                            User: (currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === userUpnPa)?.UPN,
                            Notes: ""
                        })
                    })
                })
            }
        })

        setSequenceCheckData(sequenceDateData)
    }, [checkAllTimesheets, weekCheckDates, currentUser?.Data?.Email])

    // copy from modal
    const handleCheckCopy = () => {
        const d = checkArray?.map((q) => ({ ...q, seqArray: q?.seqArray?.map((k, i) => ({ ...k, Date: weekDates[i] })) }))?.map((s, i) => ({
            ...s,
            Sequence: Math.max(...removeDupe(sequenceData)) + 1 + i,
            seqArray: s?.seqArray?.map((d) => ({
                ...d,
                Id: 0,
                Hour: d?.IsSubmited ? "" : d?.Hour,
                IsSubmited: false,
                Sequence: Math.max(...removeDupe(sequenceData)) + 1 + i,
                IsFavourite: false
            })),
        }))

        let p = []
        d.map((q) => q?.seqArray?.map((r) => p.push({ ...r, Id: 0 })))

        const temp = [...sequenceData, ...d]
        const isHolidayCheck = temp?.map((seq) => ({
            ...seq,
            seqArray: seq?.seqArray?.map((data) => ({
                ...data,
                // Hour: allHolidays.find((holiday) => moment(holiday?.Date).format("YYYY-MM-DD") === data?.Date) ? "" : data?.Hour,
                IsHoliday: allHolidays.find((holiday) => moment(holiday?.Date).format("YYYY-MM-DD") === data?.Date) ? data?.Hour !== "" ? false : true : false,
                Holiday: allHolidays.find((holiday) => moment(holiday?.Date).format("YYYY-MM-DD") === data?.Date) ? allHolidays?.find((holiday) => moment(holiday?.Date).format("YYYY-MM-DD") === data?.Date)?.Name : ""
            }))
        }))
        setSequenceData(isHolidayCheck)
        setAllTimesheetsResponse([...allTimesheetsResponse, ...p])
        setCheckArray([])
    }

    // check button change for copy from modal
    const handleCopyChange = (data) => {
        CurrentWeek();
        const ar = checkArray?.some((d) => data === d);
        if (!ar) {
            const t = data?.seqArray?.some((d) => currentWeek?.some((r) => d?.Date === r))
            const a = checkArray?.some((d) => d?.seqArray?.some((f) => currentWeek?.some((r) => f?.Date === r)))
            if (t && a) {
                setCheckArray([...checkArray, data])
            } else {
                setCheckArray([data])
            }
        }
        else {
            setCheckArray(checkArray?.filter((d) => d !== data))
        }
    }

    // copy from modal
    const handleCopyDateChange = (direction) => {
        if (direction === "prev") {
            setCheckDate((prev) => moment(prev).subtract(isMobileView ? 1 : 7, "d").format("YYYY-MM-DD"));
        } else if (direction === "next") {
            setCheckDate((prev) => moment(prev).add(isMobileView ? 1 : 7, "d").format("YYYY-MM-DD"));
        } else {
            setCheckDate(moment()._d);
        }
    }

    // Get Project, Categories, Disiplines, Functions, Favourites, AllHolidays
    useEffect(() => {
        let subscribed = true;

        setIsPromiseLoading(true)
        setAllProjects([])
        setAllServiceCategories([])
        setAllServiceDisciplines([])
        setAllFunctions([])
        setAllHolidays([])

        Promise.all([getProjects(), getAllServiceCategories(), getServiceDesiplines(), getAllFunctions(), getHolidayByCountryAndYear(moment().format("YYYY"), currentUser?.Data?.PreferredCountryId,)]).then((response) => {
            if (subscribed) {
                const projectResponse = response[0]
                const serviceCategoryResponse = response[1]
                const serviceDisiplineResponse = response[2]
                const teamsResponse = response[3]
                const allHolidays = response[4]

                if (typeof projectResponse?.Data === "object" && projectResponse?.Data?.length >= 0) {
                    setAllProjects(projectResponse?.Data)
                } else {
                    handleError(projectResponse)
                }

                if (typeof serviceCategoryResponse?.Data === "object" && serviceCategoryResponse?.Data?.length >= 0) {
                    setAllServiceCategories(serviceCategoryResponse?.Data)
                } else {
                    handleError(serviceCategoryResponse)
                }

                if (typeof serviceDisiplineResponse?.Data === "object" && serviceDisiplineResponse?.Data?.length >= 0) {
                    setAllServiceDisciplines(serviceDisiplineResponse?.Data)
                } else {
                    handleError(serviceDisiplineResponse)
                }

                if (typeof teamsResponse?.Data === "object" && teamsResponse?.Data?.length >= 0) {
                    setAllFunctions(teamsResponse?.Data)
                } else {
                    handleError(teamsResponse)
                }

                if (typeof allHolidays?.Data === "object" && allHolidays?.Data?.length >= 0) {
                    setAllHolidays(allHolidays?.Data)
                } else {
                    handleError(allHolidays)
                }
            }
        }).catch((error) => {
            if (subscribed) {
                handleError(error)
            }
        }).finally(() => {
            if (subscribed) {
                setIsPromiseLoading(false);
            }
        })
    }, [])

    // Get AllTimesheets
    const GetAllTimesheets = async (email) => {
        setIsGetAllTimesheetLoading(true);
        if ((currentUser?.Data?.PersonalAssistantManager ?? [])?.length > 0) {
            await getAllTimeSheets(weekDates[0], weekDates?.at(-1), email).then((response) => {
                if (typeof response?.Data?.TimeSheet === "object" && response?.Data?.TimeSheet?.length >= 0) {
                    const timeSheetsData = (response?.Data?.TimeSheet ?? [])?.map((timeSheet, timesheetIndex) => ({
                        ...timeSheet,
                        IndexId: timesheetIndex,
                        Date: moment(timeSheet?.Date).format("YYYY-MM-DD"),
                    }))
                    setAllTimesheetsResponse(timeSheetsData)
                    setAllTimesheets(timeSheetsData)
                    setCheckAllTimesheets(timeSheetsData)
                    checkSubmitedMonths(response?.Data?.SubmittedMonth)
                    setDefaultHolidaySelection({
                        FunctionId: response?.Data?.FunctionId,
                        ServiceCategoriesId: response?.Data?.ServiceCategoriesId,
                        ServiceDisciplinesId: response?.Data?.ServiceDisciplinesId,
                    })
                } else {
                    handleError(response)
                }
            }).catch((error) => {
                console.warn("error", error)
            }).finally(() => {
                setIsGetAllTimesheetLoading(false)
            })
        }

        return
    }

    // Get AllFavourites
    useEffect(() => {
        if (currentUser?.Data?.PersonalAssistantManager?.length > 0 && typeof userUpnPa === "string" && userUpnPa) {
            const userEmail = currentUser?.Data?.PersonalAssistantManager?.find((u) => u?.UPN === userUpnPa)?.UPN
            setIsLoading(true)
            getUserFavourite(userEmail).then((response) => {
                if (response?.Success) {
                    setAllFourites(response?.Data)
                } else {
                    setAllFourites([])
                }
            }).catch((error) => {
                console.warn("error", error);
            }).finally(() => {
                setIsLoading(false);
            })
        }
    }, [userUpnPa, currentUser?.Data?.PersonalAssistantManager])

    // for copy from modal
    useEffect(() => {
        setIsCheckSubmited(checkAllTimesheets.length > 0 ? checkAllTimesheets[0]?.IsSubmited : false)
    }, [checkAllTimesheets])

    // Timesheet getAll useEffect
    useEffect(() => {
        let subscribed = true
        if (currentUser?.Data?.PersonalAssistantManager?.length > 0 && start && end && userUpnPa) {
            setIsLoading(true)
            getAllTimeSheets(start, end, userUpnPa).then((response) => {
                if (subscribed) {
                    if (typeof response?.Data?.TimeSheet === "object" && response?.Data?.TimeSheet?.length >= 0) {
                        const timeSheetsData = response?.Data?.TimeSheet?.map((timeSheet, timesheetIndex) => ({
                            ...timeSheet,
                            IndexId: timesheetIndex,
                            Date: moment(timeSheet?.Date).format("YYYY-MM-DD"),
                        }))
                        setAllTimesheetsResponse(timeSheetsData)
                        setAllTimesheets(timeSheetsData)
                        setCheckAllTimesheets(timeSheetsData)
                        checkSubmitedMonths(response?.Data?.SubmittedMonth)
                        setDefaultHolidaySelection({ FunctionId: response?.Data?.FunctionId, ServiceCategoriesId: response?.Data?.ServiceCategoriesId, ServiceDisciplinesId: response?.Data?.ServiceDisciplinesId })
                    } else {
                        handleError(response)
                    }
                }
            }).catch((error) => {
                if (subscribed) {
                    console.warn("error", error)
                }
            }).finally(() => {
                setIsLoading(false)
            });
        } else {
            if (subscribed) {
                setAllTimesheetsResponse([])
                setAllTimesheets([])
                setCheckAllTimesheets([])
            }
        }

        return () => {
            subscribed = false;
        }
    }, [start, end, userUpnPa])

    // Copy Timesheet getAll useEffect
    useEffect(() => {
        let subscribed = true;
        if (isCopyModalOpen && weekCheckDates[0] && weekCheckDates?.at(-1)) {
            setIsLoading(true)
            getAllTimeSheets(weekCheckDates[0], weekCheckDates?.at(-1), userUpnPa).then((response) => {
                if (subscribed) {
                    if (typeof response?.Data?.TimeSheet === "object" && response?.Data?.TimeSheet?.length >= 0) {
                        const timeSheetsData = response?.Data?.TimeSheet?.map((timeSheet, timesheetIndex) => ({
                            ...timeSheet,
                            IndexId: timesheetIndex,
                            Date: moment(timeSheet?.Date).format("YYYY-MM-DD"),
                        }))
                        // setAllTimesheetsResponse(timeSheetsData)
                        setCheckAllTimesheets(timeSheetsData)
                    } else {
                        handleError(response)
                    }
                }
            }).catch((error) => {
                if (subscribed) {
                    console.warn("error", error)
                }
            }).finally(() => {
                setIsLoading(false)
            });
        } else {
            if (subscribed) {
                setAllTimesheetsResponse([])
                setCheckAllTimesheets([])
            }
        }

        return () => {
            subscribed = false;
        }
    }, [weekCheckDates[0], weekCheckDates?.at(-1), userUpnPa])

    // Hide & Show JQuery
    isMobileView && $(window).on("scroll", function () {
        if ($(this).scrollTop() > 50) {
            $(".back-to-top").fadeIn();
        } else {
            $(".back-to-top").fadeOut();
        }
    });

    const monthRemoveDuplicate = (timesheet) => {
        let unique = [];
        if (timesheet?.length > 0) {
            timesheet?.forEach((e) => {
                const exists = unique?.some(
                    (item) => item?.Sequence === e?.Sequence && item?.ProjectId === e?.ProjectId
                );

                if (!exists) {

                    unique.push({ Sequence: e?.Sequence, ProjectId: e?.ProjectId, FunctionId: e?.FunctionId, ServiceCategoriesId: e?.ServiceCategoriesId, ServiceDisciplinesId: e?.ServiceDisciplinesId });
                }
            });
        }

        return unique;
    }

    const getMonthDatesByWeek = (monthName, year) => {
        const startOfMonth = moment(`${monthName} ${year}`, 'MMMM YYYY').startOf('month');
        const endOfMonth = moment(`${monthName} ${year}`, 'MMMM YYYY').endOf('month');
        const weeks = [];

        // Start on the Monday before the first date of the month, if needed
        let current = startOfMonth.clone();
        if (current.isoWeekday() !== 1) {
            current.subtract(current.isoWeekday() - 1, 'days'); // Move to the previous Monday
        }

        // Iterate until the end of the last week (including next month if necessary)
        while (current.isBefore(endOfMonth.clone().add(1, 'week').startOf('isoWeek'), 'day')) {
            const week = [];

            // Collect 7 days for the current week
            for (let i = 0; i < 7; i++) {
                week.push(current.format('YYYY-MM-DD')); // Format the date as needed
                current.add(1, 'day');
            }

            weeks.push(week);
        }

        return weeks;
    }

    const weekTotalHours = (data) => {
        let total = 0
        data?.filter((a) => a?.array.length > 0)?.forEach((d) => {
            d?.array?.map((x) => {
                total = total + Number(x?.Hour)
            })
        })
        return total
    }

    const GetAllTimeSheetPreview = async () => {
        const month = currentDateInRange().submitMonth
        const year = moment(weekDates[0]).year()
        const firstDate = moment(`${month} ${year}`, 'MMMM YYYY').startOf('month').format('YYYY-MM-DD');
        const lastDate = moment(`${month} ${year}`, 'MMMM YYYY').endOf('month').format('YYYY-MM-DD');

        setIsLoading(true)
        await getAllTimeSheetPreview(firstDate, lastDate, userUpnPa).then((response) => {
            if (typeof response?.Data?.TimeSheet === "object" && response?.Data?.TimeSheet?.length > 0) {
                setIsPreviewModal(true)
                const groupedByWeek = getMonthDatesByWeek(month, year).map(week => {
                    return week.map(date => {
                        const matchingEntries = response?.Data?.TimeSheet?.filter(entry => entry?.Date?.startsWith(date));
                        return {
                            monthDate: date,
                            array: matchingEntries, // Add matching entries for each date
                        };
                    });
                });
                setPreviewData(response?.Data?.TimeSheet)
                setAllTimeSheetPreview(groupedByWeek)
            } else {
                setPreviewData([])
                setAllTimeSheetPreview([])
            }
        })
            .catch((error) => handleError(error))
            .finally(() => setIsLoading(false))
    }

    const getComment = (data, seq) => {
        const comment = data?.map(date => {
            if (!date?.array?.length) return ""

            const matchingItem = date.array.find(item =>
                moment(item?.Date).format("YYYY-MM-DD") === date?.monthDate &&
                item?.ServiceCategoriesId === seq?.ServiceCategoriesId &&
                item?.ServiceDisciplinesId === seq?.ServiceDisciplinesId &&
                item?.ProjectId === seq?.ProjectId &&
                item?.FunctionId === seq?.FunctionId &&
                item?.Sequence === seq?.Sequence &&
                item?.Comment
            )

            return matchingItem?.Comment || ""
        }).filter(comment => comment !== "")

        return comment[0]
    }

    const handleSubmitPreviewData = async () => {
        const month = currentDateInRange().submitMonth
        const year = moment(weekDates[0]).year()
        const startDate = moment(`${month} ${year}`, 'MMMM YYYY').startOf('month').format('YYYY-MM-DD');
        const endDate = moment(`${month} ${year}`, 'MMMM YYYY').endOf('month').format('YYYY-MM-DD');
        const payload = {
            StartDate: startDate,
            EndDate: endDate,
            User: userUpnPa
        }

        setIsPreviewSubmit(true)
        await submitTimeSheetPreview(payload).then((response) => {
            if (response.Success) {
                toast.success("Timesheet submitted successfully")
                setIsPreviewModal(false)
            } else {
                handleError(response)
            }
            GetAllTimesheets(userUpnPa && (currentUser?.Data?.PersonalAssistantManager ?? [])?.find((u) => u?.UPN === userUpnPa)?.UPN)
            setAllTimeSheetPreview([])
            setPreviewData([])
        })
            .catch((error) => handleError(error))
            .finally(() => setIsPreviewSubmit(false))

    }

    useEffect(() => {
        setAllTimeSheetPreview([])
        setPreviewData([])
    }, [userUpnPa])

    return (
        <>
            {(isLoading || isPromiseLoading || isPreviewSubmit || isGetAllTimesheetLoading) && <Loader />}

            <div className="new-timesheet">
                <main id="main" className="timesheet-main">
                    <div className="pagetitle mb" id="pagetitle">
                        <h1>Registration</h1>
                    </div>
                    <section className="section">
                        {/* Calendar Header */}
                        <div className="calendar-header mb-3 d-flex justify-content-between">
                            <div className="d-flex justify-content-between align-items-center">
                                {/* Calendar */}
                                <div className="calendar input-group d-flex align-items-center me-3">
                                    <button
                                        type="button"
                                        onClick={() => handleDateChange("prev")}
                                        className="input-group-prepend btn btn-sm btn-icon-left"
                                        title="Previous day"
                                    >
                                        <i className="fa-solid fa-chevron-left" />
                                    </button>

                                    <div className="px-3 py-2">
                                        <h6 className="mb-0 fw-medium text-dark text-center">
                                            {isMobileView
                                                ? moment(weekDates[0]).format("DD-MM-YYYY")
                                                : <>
                                                    {moment(calendarDate).startOf("isoWeek").format("MMM DD")}
                                                    {" - "}
                                                    {moment(calendarDate).startOf("isoWeek").format("MMM") !== moment(calendarDate).endOf("isoWeek").format("MMM")
                                                        ? moment(calendarDate).endOf("isoWeek").format("MMM DD")
                                                        : moment(calendarDate).endOf("isoWeek").format("DD")
                                                    }
                                                    {", "}
                                                    {moment(calendarDate).year()}
                                                    {", Week "}
                                                    {moment(calendarDate).isoWeek()}
                                                </>
                                            }
                                        </h6>
                                    </div>

                                    <button
                                        type="button"
                                        onClick={() => handleDateChange("next")}
                                        className="input-group-append btn btn-sm btn-icon-right"
                                        title="Next day"
                                    >
                                        <i className="fa-solid fa-chevron-right" />
                                    </button>
                                </div>

                                {/* Calendar Btn */}
                                <div className="calendar-btn me-3">
                                    <ReactDatePicker
                                        selected={moment(calendarDate)._d}
                                        dateFormat="dd/MM/yyyy"
                                        onChange={(date) => date && setCalendarDate(moment(date).format("YYYY-MM-DD"))}
                                        dayClassName={(date) => calendarDate && date.toDateString() === moment(calendarDate)._d.toDateString() ? "app-theme-bg-color" : ""}
                                        customInput={<CustomDatePicker />}
                                        calendarStartDay={1}
                                        todayButton="Today"
                                    />
                                </div>

                                {/* PA Select */}
                                <div className="user-select me-3">
                                    <Select
                                        value={userUpnPa ? (currentUser?.Data?.PersonalAssistantManager?.length > 0 && ({
                                            label: currentUser?.Data?.PersonalAssistantManager?.find((u) => u?.UPN === userUpnPa)?.Name,
                                            value: userUpnPa
                                        })) : ({
                                            label: "Select user",
                                            value: "Select user"
                                        })}
                                        onChange={(e) => setUserUpnPa(e.value)}
                                        options={currentUser?.Data?.PersonalAssistantManager.length > 0
                                            ? currentUser?.Data?.PersonalAssistantManager?.map((user) => (
                                                ({ label: user?.Name, value: user?.UPN })
                                            ))
                                            : []}
                                        className="form-control p-0"
                                        placeholder="Select user"
                                        styles={{
                                            control: (baseStyles) => ({
                                                ...baseStyles,
                                                marginTop: 2,
                                                border: "none",
                                                boxShadow: "none",
                                            }),
                                        }}
                                        components={{
                                            IndicatorSeparator: () => null,
                                        }}
                                    />
                                </div>

                                {/* Copy Btn */}
                                {!disableCondition2 &&
                                    <div className="copy-btn me-3">
                                        <button
                                            className="btn btn-primary btn"
                                            disabled={(disableCondition1 || lockPeriodDisableCondition) && disableCondition4}
                                            onClick={() => {
                                                setCheckArray([])
                                                setCheckDate(calendarDate)
                                                setIsCopyModalOpen(true)
                                            }}
                                        >
                                            <i className="fa-solid fa-copy" />
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>

                        {/* Main Body */}
                        <div className="custom-table d-flex flex-wrap mt-5">
                            <div className="col-12 week-header text-center">
                                <span className="week-count">
                                    Week {moment(calendarDate).isoWeek()}
                                </span>
                            </div>
                            <table className="table tableCustom table-hover valignM tableHours">
                                <thead className="table-header">
                                    <tr>
                                        <th scope="col">&nbsp;</th>
                                        {/* <th scope="col">&nbsp;</th> */}
                                        <th scope="col">&nbsp;</th>
                                        <th scope="col">Tasks</th>
                                        {weekDates && weekDates?.length > 0 &&
                                            weekDates?.map((date, dateIndex) =>
                                                <th key={dateIndex} scope="col">
                                                    <span className="week">{moment(date).format("ddd")}</span>
                                                    <span className="day">{moment(date).format("MMM DD")}</span>
                                                </th>
                                            )}
                                    </tr>
                                </thead>
                                <tbody className="table-body">
                                    {sequenceData && sequenceData?.length > 0 && (
                                        sequenceData?.map((data, index) =>
                                            <tr key={index} className="table-row">
                                                <td className="td-copy">
                                                    <button
                                                        className="btn form-control"
                                                        disabled={checkIsCopyDisable(data)}
                                                        // disabled={disableCondition1 || lockPeriodDisableCondition}
                                                        onClick={() => handleOnClickCopy(data?.seqArray, data?.IsWeekSubmited)}
                                                    >
                                                        <i className="fa-solid fa-copy" />
                                                    </button>
                                                </td>
                                                <td className="td-delete">
                                                    <button
                                                        className="btn form-control"
                                                        disabled={checkIsDeleteDisable(data)}
                                                        // disabled={data.hasOwnProperty("IsWeekSubmited")
                                                        //     ? (data?.IsWeekSubmited || lockPeriodDisableCondition)
                                                        //     : (disableCondition2 || lockPeriodDisableCondition)
                                                        // }
                                                        onClick={() => handleOnClickDelete(data)}
                                                    >
                                                        <i className="fa-solid fa-trash-can" />
                                                    </button>
                                                </td>
                                                <td className="td-btn" style={{ position: "relative" }}>
                                                    <button
                                                        type="button"
                                                        className="form-control btn btn-form-modal p-0"
                                                        disabled={checkIsProjectDisable(data)}
                                                        // disabled={data.hasOwnProperty("IsWeekSubmited")
                                                        //     ? (newDisableCondi?.some((week) => week?.weekDiffMonths)
                                                        //         ? (lockedMonth?.some((month) => month === moment(sequenceData[0]?.seqArray[0]?.Date, "YYYY-MM-DD").format("YYYY-MM")) === true
                                                        //             && lockedMonth?.some((month) => month === moment(sequenceData[0]?.seqArray[6]?.Date, "YYYY-MM-DD").format("YYYY-MM")) === true)
                                                        //         : (data?.IsWeekSubmited || lockPeriodDisableCondition))
                                                        //     : (disableCondition2 || lockPeriodDisableCondition)
                                                        // }
                                                        // disabled={data.hasOwnProperty("IsWeekSubmited")
                                                        //     ? (data?.IsWeekSubmited || lockPeriodDisableCondition)
                                                        //     : (disableCondition2 || lockPeriodDisableCondition)
                                                        // }
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#editproject"
                                                        onClick={() => handleSetData(data)}
                                                    >
                                                        <div className="text-start px-3">
                                                            <div className="fw-medium project-display">
                                                                {(allServiceCategories ?? [])?.find((cate) => cate?.Id === data?.seqArray[0]?.ServiceCategoriesId)?.ServiceCategoriesName ?? "--"}
                                                                {" - "}
                                                                {(allServiceDisciplines ?? [])?.find((disc) => disc?.Id === data?.seqArray[0]?.ServiceDisciplinesId)?.ServiceDisciplinesName ?? "--"}
                                                            </div>
                                                            <div className="text-black-50 comments-display">
                                                                {(allProjects ?? [])?.find((pro) => pro?.Id === data?.seqArray[0]?.ProjectId)?.ProjectName ?? "--"}
                                                                {" - "}
                                                                {(allFunctions ?? [])?.find((func) => func?.Id === data?.seqArray[0]?.FunctionId)?.Name ?? "--"}
                                                            </div>
                                                            <div className="text-black-50 comments-display">
                                                                {checkIsProjectDisable(data) && (data?.seqArray[0]?.Comment ? `${data?.seqArray[0]?.Comment}` : "--")}
                                                            </div>
                                                        </div>
                                                    </button>

                                                    {/* {checkIsProjectDisable(data) && data?.seqArray.some((a) => a?.IsSubmited && a?.Comment) &&
                                                        <React.Fragment key={index}>
                                                            {!tooltipVisible?.[index]?.enable && (
                                                                <span
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setTooltipVisible((prevState) => ({
                                                                            ...prevState,
                                                                            [index]: { enable: true },
                                                                        }));
                                                                    }}
                                                                    style={{ zIndex: 9999, cursor: "pointer" }}
                                                                    className="your-class-name"
                                                                >
                                                                    <i
                                                                        className="fa-regular fa-comment"
                                                                        data-tip
                                                                        data-for={`tooltip-${index}`}
                                                                        style={{
                                                                            position: "absolute",
                                                                            top: "9px",
                                                                            right: "12px",
                                                                        }}
                                                                    />
                                                                </span>
                                                            )}
                                                            {tooltipVisible?.[index]?.enable && (
                                                                <span
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "9px",
                                                                        right: "12px",
                                                                        userSelect: "none",
                                                                        cursor: "pointer",
                                                                    }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setTooltipVisible((prevState) => ({
                                                                            ...prevState,
                                                                            [index]: { enable: false },
                                                                        }));
                                                                    }}
                                                                    data-tip
                                                                    data-for={`tooltip-${index}`}
                                                                >
                                                                    {data?.seqArray.find((a) => a?.IsSubmited && a?.Comment)?.Comment}
                                                                </span>
                                                            )}
                                                        </React.Fragment>
                                                    } */}

                                                </td>
                                                {data?.seqArray && data?.seqArray?.length > 0 && (
                                                    data?.seqArray?.map((timesheet, timesheetIndex) =>
                                                        <td key={timesheetIndex} className="td-time-input">
                                                            {!timesheet?.IsHoliday ? (
                                                                <>
                                                                    <span className="week">{moment(timesheet?.Date).format("MMM DD")}</span>
                                                                    <input
                                                                        className="form-control form2"
                                                                        value={timesheet?.Hour}
                                                                        id={`${timesheet?.Sequence}-${timesheet?.IsMobile ? 1 : 0}-${moment(timesheet?.Date).format("YYYY-MM-DD")}`}
                                                                        onChange={(e) => handleOnTimeInput(data, timesheet?.Date, e.target.value)}
                                                                        onBlur={(e) => handleAutoSaveOnTimeChange(timesheet, e.target.id)}
                                                                        disabled={timesheet?.IsSubmited || timesheetPeriodDisable(timesheet?.Date)}
                                                                        type="text"
                                                                        maxLength="6"
                                                                        autoComplete="off"
                                                                    />
                                                                    {timesheet?.Id !== 0 && (timesheet?.IsSubmited
                                                                        ? timesheet?.Notes && <React.Fragment>
                                                                            <a
                                                                                className={`hour-notes ${timesheet?.IsMobile}-${timesheet?.Sequence}-${moment(timesheet?.Date).format("YYYY-MM-DD")}`}
                                                                                onClick={() => {
                                                                                    setInputSeqData(timesheet)
                                                                                    setInputNotes(timesheet?.Notes ?? "")
                                                                                }}
                                                                                data-bs-toggle={timesheet?.IsSubmited ? "" : "modal"}
                                                                                data-bs-target={timesheet?.IsSubmited ? "" : "#notesmodal"}
                                                                            >
                                                                                <i
                                                                                    className="fa-regular fa-message"
                                                                                    disabled={timesheet?.IsSubmited || lockPeriodDisableCondition}
                                                                                />
                                                                            </a>
                                                                            <Tooltip anchorSelect={`.${timesheet?.IsMobile}-${timesheet?.Sequence}-${moment(timesheet?.Date).format("YYYY-MM-DD")}`} place="top">
                                                                                {timesheet?.Notes}
                                                                            </Tooltip>
                                                                        </React.Fragment>
                                                                        : (<React.Fragment>
                                                                            <a
                                                                                className={`hour-notes ${timesheet?.IsMobile}-${timesheet?.Sequence}-${moment(timesheet?.Date).format("YYYY-MM-DD")}`}
                                                                                onClick={() => {
                                                                                    setInputSeqData(timesheet)
                                                                                    setInputNotes(timesheet?.Notes ?? "")
                                                                                }}
                                                                                data-bs-toggle={timesheet?.IsSubmited ? "" : "modal"}
                                                                                data-bs-target={timesheet?.IsSubmited ? "" : "#notesmodal"}
                                                                            >
                                                                                <i
                                                                                    className="fa-regular fa-message"
                                                                                    disabled={timesheet?.IsSubmited || lockPeriodDisableCondition}
                                                                                />
                                                                            </a>
                                                                            <Tooltip anchorSelect={`.${timesheet?.IsMobile}-${timesheet?.Sequence}-${moment(timesheet?.Date).format("YYYY-MM-DD")}`} place="top">
                                                                                {timesheet?.Notes}
                                                                            </Tooltip>
                                                                        </React.Fragment>)
                                                                    )}

                                                                    {/* {timesheet?.Id !== 0 && timesheet?.Notes && timesheet?.IsSubmited && (
                                                                        <React.Fragment>
                                                                            <a className={`hour-notes ${timesheet?.IsMobile}-${timesheet?.Sequence}-${moment(timesheet?.Date).format("YYYY-MM-DD")}`}>
                                                                                <i className="fa-regular fa-message" />
                                                                            </a>
                                                                            <Tooltip anchorSelect={`.${timesheet?.IsMobile}-${timesheet?.Sequence}-${moment(timesheet?.Date).format("YYYY-MM-DD")}`} place="top">
                                                                                {timesheet?.Notes}
                                                                            </Tooltip>
                                                                        </React.Fragment>
                                                                    )} */}
                                                                </>
                                                            ) : (
                                                                <div className="holiday-div">
                                                                    <a onClick={() => handleEnableHoliday(timesheet)} className={`${timesheet?.IsSubmited ? "holiday-disable" : "holiday"} ${timesheet?.IsMobile}-${timesheet?.Sequence}-${moment(timesheet?.Date).format("YYYY-MM-DD")}`}>
                                                                        <span className="week">{moment(timesheet?.Date).format("MMM DD")}</span>
                                                                        <input
                                                                            className="form-control form2 border-success bg-success-50 text-success holiday-input-disable"
                                                                            defaultValue={"H"}
                                                                            id={`${timesheet?.Sequence}-${timesheet?.IsMobile ? 1 : 0}-${moment(timesheet?.Date).format("YYYY-MM-DD")}`}
                                                                            type="text" maxLength="6" autoComplete="off"
                                                                        />
                                                                    </a>
                                                                    <Tooltip anchorSelect={`.${timesheet?.IsMobile}-${timesheet?.Sequence}-${moment(timesheet?.Date).format("YYYY-MM-DD")}`} place="top">
                                                                        {timesheet?.Holiday}
                                                                    </Tooltip>
                                                                </div>
                                                            )}
                                                        </td>
                                                    )
                                                )}
                                            </tr>
                                        )
                                    )}

                                    {/* Time footer */}
                                    <tr className="table-row">
                                        <td className="add-new-row" colSpan="3">
                                            <button
                                                type="submit"
                                                className="btn btn-link add-row"
                                                // disabled={((disableCondition1 || lockPeriodDisableCondition) && disableCondition4)}
                                                disabled={checkIsAddNewRowDisable()}
                                                onClick={() => handleOnClickAddRow()}
                                            >
                                                <i className="fa-solid fa-plus me-1" />Add new row
                                            </button>
                                        </td>
                                        {totalTimeByDate && totalTimeByDate?.length > 0 &&
                                            totalTimeByDate?.map((date, dateIndex) =>
                                                <td key={dateIndex}>
                                                    {!date?.TotalTime ? "0.00" : date?.TotalTime?.toFixed(2)}
                                                </td>
                                            )
                                        }
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>
                </main>

                <div className="submit-footer d-flex justify-content-between align-itmes-center" id="submit-footer">
                    <div className="total-hours d-inline-flex justify-content-start align-itmes-center">
                        <span key={totalOfTotalTime} className="me-3 line-sm">{totalOfTotalTime?.toFixed(2)}</span>
                        <div>
                            <div className="text-md">Total Hours</div>
                            <div className="text-sm txt-gray">
                                {isMobileView
                                    ? moment(weekDates[0]).format("DD-MM-YYYY")
                                    : <>
                                        {"Week "}
                                        {moment(calendarDate).isoWeek()}
                                        {", "}
                                        {moment(calendarDate).year()}
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="submit text-end d-flex gap-3">
                        <div className="d-flex justify-content-center align-items-center p-2 text-secondary">
                            {isAutoSaving ? "Auto saving..." : ""}
                        </div>
                        <button
                            className="submit-btn btn btn-primary btn-lg btn"
                            onClick={() => setShouldCallSave(true)}
                            disabled={checkIsSaveDisable()}
                        >
                            Save
                        </button>
                        {/* {currentDateInRange()?.submitShow && !disableCondition3 && ( */}
                        {currentDateInRange()?.submitShow && (
                            <button
                                className="submit-btn btn btn-primary btn-lg btn"
                                // onClick={() => submitWeekData()}
                                onClick={() => {
                                    setExpandAll(false)
                                    setAccordionId(null)
                                    GetAllTimeSheetPreview()
                                }}
                                disabled={disableCondition3 || lockPeriodDisableCondition}
                                data-bs-toggle="modal"
                                data-bs-target="#submitpreview"
                            >
                                Submit {`(${currentDateInRange()?.submitMonth})`}
                            </button>
                        )}
                    </div>
                </div>

                {isMobileView && (
                    <div onClick={() => scrollToDiv()} className="back-to-top justify-content-center align-items-center">
                        <i className="fa-solid fa-arrow-up" />
                    </div>
                )}

                {/* Submit Preview Modal */}
                <div className="modal fade bd-example-modal-xl" id="submitpreview" >
                    <div className="modal-dialog  modal-xl">
                        <div className="modal-content" style={{ padding: "40px 0px" }}>
                            <div className="modal-header" style={{ padding: "0px 40px" }}>
                                <h5 className="modal-title">Submit Timesheet</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" />
                            </div>

                            <div className="modal-body mb-2 my-4 p-5" style={{ backgroundColor: "rgb(248 248 248)" }}>
                                <div className="form-check mb-3 d-flex align-items-center">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        style={{ boxShadow: "none", borderColor: "none" }}
                                        value=""
                                        id="flexCheckDefault"
                                        checked={expandAll}
                                        onChange={() => {
                                            setExpandAll((prev) => !prev);
                                            setAccordionId(null);
                                        }}
                                    />
                                    <label
                                        className="form-check-label fw-medium"
                                        htmlFor="flexCheckDefault"
                                        style={{ userSelect: "none", fontSize: "15px" }}
                                    >
                                        Expand all
                                    </label>
                                </div>
                                {allTimeSheetPreview && allTimeSheetPreview?.length > 0 ?
                                    allTimeSheetPreview?.map((prevData, prevIndex) =>
                                        <table key={prevIndex} className="table table-responsive mb-1">
                                            <tbody>
                                                <tr className="">
                                                    <td colSpan="3">
                                                        <button
                                                            onClick={() => {
                                                                if (expandAll) return
                                                                setAccordionId((prev) => prev !== prevIndex ? prevIndex : null)
                                                            }}
                                                            type="text"
                                                            style={{ padding: "8px 12px", border: "none", borderRadius: "5px", backgroundColor: "white", color: "black", fontSize: "14px" }}
                                                        >
                                                            {(expandAll || accordionId === prevIndex)
                                                                ? <i class="fa-solid fa-chevron-up" />
                                                                : <i class="fa-solid fa-chevron-down" />
                                                            }
                                                        </button>
                                                    </td>
                                                    <td
                                                        colSpan="6"
                                                        style={{ textAlign: "center" }}
                                                        onClick={() => {
                                                            if (expandAll) return
                                                            setAccordionId((prev) => prev !== prevIndex ? prevIndex : null)
                                                        }}
                                                    >
                                                        <div className="d-flex align-items-center justify-content-center " >
                                                            <span className="fw-bold">
                                                                {"Week "}
                                                                {moment(allTimeSheetPreview[prevIndex][0]?.monthDate).isoWeek()}
                                                                {" "}
                                                                {moment(allTimeSheetPreview[prevIndex][allTimeSheetPreview[prevIndex].length - 1]?.monthDate).format("MMMM")},&nbsp;
                                                                {moment(allTimeSheetPreview[prevIndex][allTimeSheetPreview[prevIndex].length - 1]?.monthDate).format("YYYY")}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td
                                                        colSpan="3"
                                                        style={{ textAlign: "end" }}
                                                        onClick={() => {
                                                            if (expandAll) return
                                                            setAccordionId((prev) => prev !== prevIndex ? prevIndex : null)
                                                        }}
                                                    >
                                                        <span>{weekTotalHours(allTimeSheetPreview[prevIndex])?.toFixed(2)}</span>{" "}<span className="txt-gray">Hrs.</span>
                                                    </td>
                                                </tr>
                                                <tr className={` ${(expandAll || accordionId === prevIndex) ? "" : " d-none"}`}>
                                                    <td colSpan="10" className="p-3">
                                                        <div className="">
                                                            <table className="my-1" style={{ tableLayout: "fixed", width: "100%" }}>
                                                                <thead className="table-header">
                                                                    <tr className="" align="center">
                                                                        <th style={{ width: "30%" }} align="left">Task</th>
                                                                        {prevData && prevData?.length > 0 &&
                                                                            prevData?.map((date, dateIndex) =>
                                                                                <th key={dateIndex} >
                                                                                    <span className="d-flex flex-column text-nowrap">
                                                                                        <span style={{ fontSize: "12px" }}>{moment(date?.monthDate).format("ddd").toUpperCase()} </span>
                                                                                        <span style={{ fontSize: "11px", color: "#aeaeae", fontWeight: "500" }} >{moment(date?.monthDate).format("MMM DD")}</span>
                                                                                    </span>
                                                                                </th>
                                                                            )
                                                                        }
                                                                    </tr>
                                                                </thead>

                                                                <tbody className="table-body">
                                                                    {monthRemoveDuplicate(prevData?.filter(item => item.array.length > 0)?.flatMap((a) => a?.array))?.length > 0 ?
                                                                        monthRemoveDuplicate(prevData?.filter(item => item.array.length > 0)
                                                                            ?.flatMap((a) => a?.array))
                                                                            ?.sort((a, b) => a?.Sequence - b?.Sequence)
                                                                            ?.map((seq, seqIndex) =>
                                                                                <tr key={seqIndex} className="table-row" align="center">
                                                                                    {/* proj details */}
                                                                                    <td className="td-btn" style={{ position: "relative" }}>
                                                                                        <span className="d-flex align-items-center text-start pe-3">
                                                                                            <span className="ms-2" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                                                <div className="fw-medium p-0" style={{ fontSize: "13px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                                                    {allServiceCategories && allServiceCategories?.length > 0
                                                                                                        ? allServiceCategories?.filter((cate) => cate?.Id === seq?.ServiceCategoriesId)[0]?.ServiceCategoriesName
                                                                                                        ?? "--"
                                                                                                        : "--"
                                                                                                    }{" - "}
                                                                                                    {allServiceDisciplines && allServiceDisciplines?.length > 0
                                                                                                        ? allServiceDisciplines?.filter((disc) => disc?.Id === seq?.ServiceDisciplinesId)[0]?.ServiceDisciplinesName
                                                                                                        ?? "--"
                                                                                                        : "--"
                                                                                                    }
                                                                                                </div>
                                                                                                <div className="text-black-50 p-0 text-nowrap" style={{ fontSize: "11px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                                                    {allProjects && allProjects?.length > 0
                                                                                                        ? allProjects?.filter((pro) => pro?.Id === seq?.ProjectId)[0]?.ProjectName
                                                                                                        ?? "--"
                                                                                                        : "--"
                                                                                                    }{" - "}
                                                                                                    {allFunctions && allFunctions?.length > 0
                                                                                                        ? allFunctions?.filter((func) => func?.Id === seq?.FunctionId)[0]?.Name
                                                                                                        ?? "--"
                                                                                                        : "--"
                                                                                                    }
                                                                                                </div>
                                                                                                <div className="text-black-50 p-0 text-nowrap" style={{ fontSize: "11px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                                                    {getComment(prevData, seq) ?? "--"}
                                                                                                    {/* {(() => {
                                                                                                        const comment = getComment(prevData, seq) ?? "--"
                                                                                                        return comment ?? "--"
                                                                                                    })()} */}
                                                                                                </div>
                                                                                            </span>
                                                                                        </span>
                                                                                    </td>

                                                                                    {/* date-hours */}
                                                                                    {prevData && prevData?.length > 0 &&
                                                                                        prevData?.map((date, dateIndex) => {
                                                                                            if (date?.array?.length > 0) {
                                                                                                return <td key={dateIndex} className="td-time-input" style={{ textAlign: "center", position: "relative", padding: "4px 2px" }}>
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        className="form-control form2"
                                                                                                        style={{ textAlign: "center" }}
                                                                                                        value={date?.array.find((item) =>
                                                                                                            moment(item?.Date).format("YYYY-MM-DD") === date?.monthDate &&
                                                                                                            item?.ServiceCategoriesId === seq?.ServiceCategoriesId &&
                                                                                                            item?.ServiceDisciplinesId === seq?.ServiceDisciplinesId &&
                                                                                                            item?.ProjectId === seq?.ProjectId &&
                                                                                                            item?.FunctionId === seq?.FunctionId &&
                                                                                                            item?.Sequence === seq?.Sequence
                                                                                                        )?.Hour}
                                                                                                        disabled
                                                                                                    />
                                                                                                    {date?.array.find((item) =>
                                                                                                        moment(item?.Date).format("YYYY-MM-DD") === date?.monthDate &&
                                                                                                        item?.ServiceCategoriesId === seq?.ServiceCategoriesId &&
                                                                                                        item?.ServiceDisciplinesId === seq?.ServiceDisciplinesId &&
                                                                                                        item?.ProjectId === seq?.ProjectId &&
                                                                                                        item?.FunctionId === seq?.FunctionId &&
                                                                                                        item?.Sequence === seq?.Sequence
                                                                                                    )?.Notes && (
                                                                                                            <span style={{ position: "absolute", top: "3px", right: "6px", color: "grey", fontSize: "11px" }}>
                                                                                                                <i
                                                                                                                    className="fa-regular fa-message"
                                                                                                                    data-tooltip-id={`tooltip-${dateIndex}`}
                                                                                                                    data-tooltip-content={date?.array.find((item) =>
                                                                                                                        moment(item?.Date).format("YYYY-MM-DD") === date?.monthDate &&
                                                                                                                        item?.ServiceCategoriesId === seq?.ServiceCategoriesId &&
                                                                                                                        item?.ServiceDisciplinesId === seq?.ServiceDisciplinesId &&
                                                                                                                        item?.ProjectId === seq?.ProjectId &&
                                                                                                                        item?.FunctionId === seq?.FunctionId &&
                                                                                                                        item?.Sequence === seq?.Sequence
                                                                                                                    )?.Notes}
                                                                                                                />
                                                                                                                <Tooltip id={`tooltip-${dateIndex}`} place="top" />
                                                                                                            </span>
                                                                                                        )}
                                                                                                </td>
                                                                                            } else {
                                                                                                return <td key={dateIndex} style={{ padding: "4px 2px" }}>
                                                                                                    <input type="text" className="form-control form2" disabled />
                                                                                                </td>
                                                                                            }
                                                                                        })
                                                                                    }
                                                                                </tr>
                                                                            ) : (
                                                                            <tr className="" >
                                                                                <td colSpan={8} className="text-center py-2" > No data Available</td>
                                                                            </tr>
                                                                        )
                                                                    }
                                                                    <tr>
                                                                        <td></td>
                                                                        {prevData?.some((a) => a?.array.length > 0) && prevData.map(date =>
                                                                            date?.array?.reduce((sum, item) => sum + (item?.Hour || 0), 0)
                                                                        )?.map((total) => <td className="text-center">{total.toFixed(2)}</td>)}
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    )
                                    : <div className="mt-4">
                                        <div className="d-flex justify-content-center fs-3">No Data</div>
                                    </div>
                                }
                            </div>

                            <div className="modal-footer mt-2" style={{ padding: "0px 40px" }} >
                                <div className="d-flex justify-content-center align-itmes-center me-auto">
                                    <div className="me-3 line-sm" style={{ fontSize: "36px", color: "var(--app-theme-color)" }}>{previewData.reduce((total, item) => total + item.Hour, 0)?.toFixed(2)}</div>
                                    <div className="pt-2">
                                        <div className="text-md" style={{ fontWeight: 500 }}>Total Hours</div>
                                        <div style={{ color: "gray", fontSize: "12px" }} >
                                            {currentDateInRange().submitMonth}
                                            {", "}
                                            {moment(weekDates[0]).year()}
                                        </div>
                                    </div>
                                </div>
                                <button
                                    type="button"
                                    data-bs-dismiss="modal"
                                    className="cancel-btn btn btn-transparent btn-lg m-0 me-2"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    data-bs-dismiss="modal"
                                    className="submit-btn btn btn-primary btn-lg m-0"
                                    onClick={() => handleSubmitPreviewData()}
                                >
                                    Submit({currentDateInRange().submitMonth})
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal */}
                <div className="modal fade" id="editproject">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Edit Timesheet</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" />
                            </div>
                            <div className="modal-body mb-4">
                                <form className="row g-3">
                                    {/* Function */}
                                    <div className="col-12 m-0">
                                        <label htmlFor="inputName4" className="form-label">Function</label>
                                        <Select
                                            value={allFunctions?.length > 0 && inputFunction && allFunctions?.find((func) => func?.Id === inputFunction)?.Id ? ({
                                                value: inputFunction,
                                                label: allFunctions?.find((func) => func?.Id === inputFunction)?.Name
                                            }) : ([])}
                                            onChange={(e) => {
                                                setInputFunction(Number(e.value))
                                                setInputServiceCategory(0)
                                                setInputServiceDiscipline(0)
                                            }}
                                            options={allFunctions?.length > 0 &&
                                                allFunctions.filter((d) => d?.IsActive).map((func) => (
                                                    ({ value: func?.Id, label: func?.Name })
                                                ))
                                            }
                                            className="form-control p-1 mb-3"
                                            placeholder="Select funtion"
                                            styles={{
                                                control: (baseStyles) => ({
                                                    ...baseStyles,
                                                    marginTop: 2,
                                                    border: "none",
                                                    boxShadow: "none",
                                                }),
                                            }}
                                            components={{
                                                IndicatorSeparator: () => null,
                                            }}
                                        />
                                    </div>

                                    {/* Service category */}
                                    <div className="col-12 m-0">
                                        <label htmlFor="inputName4" className="form-label">Service category</label>
                                        <Select
                                            value={allServiceCategories?.length > 0 && inputServiceCategory && allServiceCategories?.find((cate) => cate?.Id === inputServiceCategory)?.Id ? ({
                                                value: inputServiceCategory,
                                                label: allServiceCategories?.find((cate) => cate?.Id === inputServiceCategory)?.ServiceCategoriesName
                                            }) : ([])}
                                            onChange={(e) => {
                                                setInputServiceCategory(Number(e.value))
                                                setInputServiceDiscipline(0)
                                            }}
                                            options={allServiceCategories?.length > 0 && (
                                                (inputFunction
                                                    ? allServiceCategories?.filter((cate) => cate?.FunctionId === inputFunction)
                                                    : allServiceCategories
                                                )?.filter((d) => d?.IsActive)?.map((category) => (
                                                    ({ value: category?.Id, label: category?.ServiceCategoriesName })
                                                ))
                                            )}
                                            className="form-control p-1 mb-3"
                                            placeholder="Select category"
                                            styles={{
                                                control: (baseStyles) => ({
                                                    ...baseStyles,
                                                    marginTop: 2,
                                                    border: "none",
                                                    boxShadow: "none",
                                                }),
                                            }}
                                            components={{
                                                IndicatorSeparator: () => null,
                                            }}
                                        />
                                    </div>

                                    {/* Service discipline */}
                                    <div className="col-12 m-0">
                                        <label htmlFor="inputName4" className="form-label">Service discipline</label>
                                        <Select
                                            value={allServiceDisciplines?.length > 0 && inputServiceDiscipline && allServiceDisciplines?.find((discipline) => discipline?.Id === inputServiceDiscipline)?.Id ? ({
                                                value: inputServiceDiscipline,
                                                label: allServiceDisciplines?.find((discipline) => discipline?.Id === inputServiceDiscipline)?.ServiceDisciplinesName
                                            }) : ([])}
                                            onChange={(e) => setInputServiceDiscipline(Number(e.value))}
                                            options={allServiceDisciplines.length > 0 && (
                                                (inputServiceCategory
                                                    ? allServiceDisciplines?.filter((discipline) => discipline?.ServiceCategoriesId === inputServiceCategory)
                                                    : allServiceDisciplines
                                                )?.filter((d) => d?.IsActive)?.map((discipline) => (
                                                    ({ value: discipline?.Id, label: discipline?.ServiceDisciplinesName })
                                                ))
                                            )}
                                            className="form-control p-1 mb-3"
                                            placeholder="Select discipline"
                                            styles={{
                                                control: (baseStyles) => ({
                                                    ...baseStyles,
                                                    marginTop: 2,
                                                    border: "none",
                                                    boxShadow: "none",
                                                }),
                                            }}
                                            components={{
                                                IndicatorSeparator: () => null,
                                            }}
                                        />
                                    </div>

                                    {/* Project */}
                                    <div className="col-12 m-0">
                                        <label htmlFor="inputName4" className="form-label">Project</label>
                                        <Select
                                            value={allProjects?.length > 0 && inputProject && allProjects?.find((pro) => pro?.Id === inputProject)?.Id ? ({
                                                value: inputProject,
                                                label: allProjects?.find((pro) => pro?.Id === inputProject)?.ProjectName
                                            }) : ([])}
                                            onChange={(e) => setInputProject(Number(e.value))}
                                            options={allProjects?.length > 0 ? (
                                                allProjects?.filter((v) => v.IsActive === true)?.map((pro) => ({
                                                    label: pro?.ProjectName,
                                                    value: pro?.Id
                                                }))
                                            ) : (
                                                []
                                            )}
                                            className="form-control p-1 mb-3"
                                            placeholder="Select project"
                                            styles={{
                                                control: (baseStyles) => ({
                                                    ...baseStyles,
                                                    marginTop: 2,
                                                    border: "none",
                                                    boxShadow: "none",
                                                }),
                                            }}
                                            components={{
                                                IndicatorSeparator: () => null,
                                            }}
                                        />
                                    </div>

                                    {/* Comment */}
                                    <div className="col-12 m-0">
                                        <label htmlFor="comments" className="form-label">Comment</label>
                                        <textarea value={inputComment} onChange={((e) => setInputComment(e.target.value))} className="form-control" rows={4} />
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    data-bs-dismiss="modal"
                                    className="cancel-btn btn btn-transparent btn-lg m-0 me-2"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    data-bs-dismiss={`${inputFunction !== 0 &&
                                        inputServiceCategory !== 0 &&
                                        inputServiceDiscipline !== 0 &&
                                        (allServiceCategories?.filter((cate) => cate?.Id === inputServiceCategory)[0]?.ProjectSelection ? inputProject !== 0 : true)
                                        ? "modal"
                                        : ""}`}
                                    className="submit-btn btn btn-primary btn-lg m-0"
                                    onClick={() => handleSaveData()}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Notes Modal */}
                <div className="modal fade" id="notesmodal">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Edit Notes</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" />
                            </div>
                            <div className="modal-body mb-4">
                                <form className="row g-3">
                                    {/* Comment */}
                                    <div className="col-12 m-0">
                                        <label htmlFor="comments" className="form-label">Comment</label>
                                        <textarea value={inputNotes} onChange={((e) => setInputNotes(e.target.value))} className="form-control" rows={4} />
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    data-bs-dismiss="modal"
                                    className="cancel-btn btn btn-transparent btn-lg m-0 me-2"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    data-bs-dismiss="modal"
                                    className="submit-btn btn btn-primary btn-lg m-0"
                                    onClick={() => handleSetNotes()}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* check modal */}
                <div className={`modal editinfo fade copymodal ${isCopyModalOpen ? "show d-block" : "d-none"}`} id="checktimesheet">
                    <div className="modal-dialog p-0 d-flex justify-content-center align-items-center">
                        <div className="modal-content modal-custom-content">
                            <div className="modal-custom-header">
                                <div>
                                    <h2 className="">Copy Timesheet</h2>
                                </div>
                                <div>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        onClick={() => {
                                            setCheckArray([])
                                            setIsCopyModalOpen(false)
                                        }}
                                        aria-label="Close"
                                    />
                                </div>
                            </div>
                            <div className="modal-body mb-4 mt-0" >
                                <div>
                                    {/* Calendar Header */}
                                    <div className="calendar-header mb-3 d-flex justify-content-between align-items-center row">
                                        <div className="d-flex justify-content-center col gap-2">
                                            {/* Calendar */}
                                            <div className="calendar col-8 d-flex align-items-center border-0 p-0 me-3  ">
                                                <button
                                                    type="button"
                                                    onClick={() => handleCopyDateChange("prev")}
                                                    className="input-group-prepend btn btn-sm btn-icon-left"
                                                    title="Previous day"
                                                >
                                                    <i className="fa-solid fa-chevron-left" />
                                                </button>

                                                <div className="p-0">
                                                    <h6 className="m-0 fw-medium text-dark text-center py-2 px-1">
                                                        {isMobileView
                                                            ? moment(weekCheckDates[0]).format("DD-MM-YYYY")
                                                            : <>
                                                                {moment(checkDate).startOf("isoWeek").format("MMM DD")}
                                                                {" - "}
                                                                {moment(checkDate).startOf("isoWeek").format("MMM") !== moment(checkDate).endOf("isoWeek").format("MMM")
                                                                    ? moment(checkDate).endOf("isoWeek").format("MMM DD")
                                                                    : moment(checkDate).endOf("isoWeek").format("DD")
                                                                }
                                                                {", "}
                                                                {moment(checkDate).year()}
                                                                {", Week "}
                                                                {moment(checkDate).isoWeek()}
                                                            </>
                                                        }
                                                    </h6>
                                                </div>

                                                <button
                                                    type="button"
                                                    onClick={() => handleCopyDateChange("next")}
                                                    className="input-group-append btn btn-sm btn-icon-right"
                                                    title="Next day"
                                                >
                                                    <i className="fa-solid fa-chevron-right" />
                                                </button>
                                            </div>

                                            <div className="col">
                                                {/* Calendar Btn */}
                                                <div className="col">
                                                    <ReactDatePicker
                                                        selected={moment(checkDate)._d}
                                                        dateFormat="dd/MM/yyyy"
                                                        // renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled, }) => (
                                                        //     <div className="d-flex align-item-center justify-content-between px-3">
                                                        //         <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} className="btn p-0" style={{ minWidth: 0 }}>
                                                        //             {prevMonthButtonDisabled ? "<" : <b>{"<"}</b>}
                                                        //         </button>
                                                        //         <b>{moment(date).format("MMMM")}</b>
                                                        //         <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} className="btn p-0" style={{ minWidth: 0 }}>
                                                        //             {nextMonthButtonDisabled ? ">" : <b>{">"}</b>}
                                                        //         </button>
                                                        //     </div>
                                                        // )}
                                                        onChange={(date) => date && setCheckDate(moment(date).format("YYYY-MM-DD"))}
                                                        dayClassName={(date) => checkDate && date.toDateString() === moment(checkDate)._d.toDateString() ? "app-theme-bg-color" : ""}
                                                        customInput={<CustomDatePicker />}
                                                        calendarStartDay={1}
                                                        todayButton="Today"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Main Body */}
                                    <div className="custom-table d-flex flex-wrap mt-5 style-4">
                                        <div className="col-12 week-header text-center">
                                            <span className="week-count">
                                                Week {moment(checkDate).isoWeek()}
                                            </span>
                                        </div>
                                        <table className="table tableCustom table-hover valignM tableHours ">
                                            <thead className="table-header">
                                                <tr align="center">
                                                    <th scope="col">&nbsp;</th>
                                                    <th scope="col">Tasks</th>
                                                    {weekCheckDates && weekCheckDates?.length > 0 &&
                                                        weekCheckDates?.map((date, dateIndex) =>
                                                            <th key={dateIndex} scope="col">
                                                                <span className="week row">{moment(date).format("ddd")}</span>
                                                                <span className="day row fw-light ">{moment(date).format("MMM DD")}</span>
                                                            </th>
                                                        )}
                                                </tr>
                                            </thead>
                                            <tbody className="table-body">
                                                {sequenceCheckData && sequenceCheckData?.length > 0 && (
                                                    sequenceCheckData?.map((data, index) =>
                                                        <tr key={index} className="table-row">
                                                            <td className="td-copy col-2">
                                                                <div className="d-flex justify-content-center align-items-center">
                                                                    <input
                                                                        className="form-check-input m-0"
                                                                        type="checkbox"
                                                                        id="flexSwitchCheckDisabled"
                                                                        checked={checkArray?.some((d) => d === data)}
                                                                        onChange={() => handleCopyChange(data)}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td className="td-btn">
                                                                <div className="form-control btn-form-modal p-0">
                                                                    <div className="text-start px-2 py-1 customTd">
                                                                        <div className="fw-medium project-display">
                                                                            {allServiceCategories && allServiceCategories?.length > 0
                                                                                ? allServiceCategories?.filter((cate) => cate?.Id === data?.seqArray[0]?.ServiceCategoriesId)[0]?.ServiceCategoriesName
                                                                                ?? "--"
                                                                                : "--"
                                                                            }{" - "}
                                                                            {allServiceDisciplines && allServiceDisciplines?.length > 0
                                                                                ? allServiceDisciplines?.filter((disc) => disc?.Id === data?.seqArray[0]?.ServiceDisciplinesId)[0]?.ServiceDisciplinesName
                                                                                ?? "--"
                                                                                : "--"
                                                                            }
                                                                        </div>
                                                                        <div className="text-black-50 comments-display">
                                                                            {allProjects && allProjects?.length > 0
                                                                                ? allProjects?.filter((pro) => pro?.Id === data?.seqArray[0]?.ProjectId)[0]?.ProjectName
                                                                                ?? "--"
                                                                                : "--"
                                                                            }{" - "}
                                                                            {allFunctions && allFunctions?.length > 0
                                                                                ? allFunctions?.filter((func) => func?.Id === data?.seqArray[0]?.FunctionId)[0]?.Name
                                                                                ?? "--"
                                                                                : "--"
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            {data?.seqArray && data?.seqArray?.length > 0 && (
                                                                data?.seqArray?.map((timesheet, timesheetIndex) =>
                                                                    <td key={timesheetIndex} className="td-time-input">
                                                                        <span className="week">{moment(timesheet?.Date).format("MMM DD")}</span>
                                                                        <div className="hour-div d-flex justify-content-center align-items-center">
                                                                            {timesheet?.Hour}
                                                                        </div>
                                                                    </td>
                                                                )
                                                            )}
                                                        </tr>
                                                    )
                                                )}

                                                {/* Time footer */}
                                                <tr className="table-row" align="center">
                                                    <td colSpan="2">
                                                    </td>
                                                    {totalTimeByDateCopyModal && totalTimeByDateCopyModal?.length > 0 && (
                                                        totalTimeByDateCopyModal?.map((date, dateIndex) =>
                                                            <td key={dateIndex} >
                                                                {!date?.TotalTime ? "0.00" : date?.TotalTime?.toFixed(2)}
                                                            </td>
                                                        )
                                                    )}
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <hr />

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn cancel-btn btn-transparent btn-lg me-2"
                                    onClick={() => {
                                        setCheckArray([])
                                        setIsCopyModalOpen(false)
                                    }}
                                    data-bs-dismiss="modal"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    onClick={() => {
                                        handleCheckCopy()
                                        setIsCopyModalOpen(false)
                                    }}
                                    className="btn copy-btn btn-primary btn-lg"
                                    data-bs-dismiss="modal"
                                >
                                    Copy
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Timesheet


const styles = {
    accordion: {
        width: "90%",
        margin: "20px 0",
        border: "1px solid #ddd",
        borderRadius: "5px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        padding: "0px 25px",
        display: "flex",
        flexDirection: "column",
    },
    button: {
        width: "100%",
        padding: "10px",
        backgroundColor: "#007bff",
        color: "#fff",
        fontSize: "16px",
        fontWeight: "bold",
        border: "none",
        cursor: "pointer",
        borderRadius: "5px 5px 0 0",
    },
    body: {
        padding: "20px",
        backgroundColor: "#f9f9f9",
        borderTop: "1px solid #ddd",
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
    },
    cell: {
        border: "1px solid #ddd",
        padding: "10px",
        textAlign: "left",
    },
};